var _defs, _rect, _image, _path, _path2, _image2, _image3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _polygon, _polygon2, _polygon3, _path18, _g2, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle, _polygon4, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _polyline, _path55, _path56, _path57, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _rect2, _image4, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g3, _polygon30, _polygon31, _polygon32, _path74, _g4, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _circle2, _polygon33, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _polyline2, _path111, _path112, _path113, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _rect3, _image5, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _path114;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11H(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.29 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#231f20;}.cls-3{fill:#bc141a;}.cls-4{fill:#fde4e0;}.cls-5{fill:#9f1d20;}.cls-6{fill:#8d321d;}.cls-7{fill:#bd6956;}.cls-8{fill:url(#linear-gradient);}.cls-9{fill:url(#linear-gradient-2);}.cls-10{fill:url(#linear-gradient-3);}.cls-11{clip-path:url(#clip-path);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:url(#linear-gradient-9);}.cls-18{fill:url(#linear-gradient-10);}.cls-19{fill:url(#linear-gradient-11);}.cls-20{fill:url(#linear-gradient-12);}.cls-21{fill:url(#linear-gradient-13);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-15);}.cls-24{fill:url(#linear-gradient-16);}.cls-25{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}.cls-34{fill:url(#linear-gradient-26);}.cls-35{fill:url(#linear-gradient-27);}.cls-36{fill:url(#linear-gradient-28);}.cls-37{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#linear-gradient-39);}.cls-48{fill:url(#linear-gradient-40);}.cls-49{fill:url(#linear-gradient-41);}.cls-50{fill:url(#linear-gradient-42);}.cls-51{fill:url(#linear-gradient-43);}.cls-52{fill:url(#linear-gradient-44);}.cls-53{fill:url(#linear-gradient-45);}.cls-54{fill:url(#linear-gradient-46);}.cls-55{fill:url(#linear-gradient-47);}.cls-56{fill:url(#linear-gradient-48);}.cls-57{fill:url(#linear-gradient-49);}.cls-58{fill:url(#linear-gradient-50);}.cls-59{fill:url(#linear-gradient-51);}.cls-60{fill:url(#linear-gradient-52);}.cls-61{fill:url(#linear-gradient-53);}.cls-62{fill:url(#linear-gradient-54);}.cls-63{fill:url(#linear-gradient-55);}.cls-64{fill:url(#linear-gradient-56);}.cls-65{fill:url(#linear-gradient-57);}.cls-66{fill:url(#linear-gradient-58);}.cls-67{fill:url(#linear-gradient-59);}.cls-68{fill:url(#linear-gradient-60);}.cls-69{fill:url(#linear-gradient-61);}.cls-70{fill:url(#linear-gradient-62);}.cls-71{fill:url(#linear-gradient-63);}.cls-72{fill:url(#linear-gradient-64);}.cls-73{fill:url(#linear-gradient-65);}.cls-74{fill:url(#linear-gradient-66);}.cls-75{fill:url(#linear-gradient-67);}.cls-76{fill:url(#linear-gradient-68);}.cls-77{fill:url(#linear-gradient-69);}.cls-78{fill:url(#linear-gradient-70);}.cls-79{fill:url(#linear-gradient-71);}.cls-80{fill:url(#linear-gradient-72);}.cls-81{fill:url(#linear-gradient-73);}.cls-82{fill:url(#linear-gradient-74);}.cls-83{fill:url(#linear-gradient-75);}.cls-84{fill:url(#linear-gradient-76);}.cls-85{fill:#cc1217;}.cls-86,.cls-89{fill:#fdddc5;}.cls-86,.cls-88{opacity:0.19;}.cls-87{fill:url(#linear-gradient-77);}.cls-90{fill:url(#linear-gradient-78);}.cls-91{fill:url(#linear-gradient-79);}.cls-92{fill:url(#linear-gradient-80);}.cls-93{fill:url(#linear-gradient-81);}.cls-94{fill:url(#linear-gradient-82);}.cls-95{fill:url(#linear-gradient-83);}.cls-96{fill:url(#linear-gradient-84);}.cls-97{fill:url(#linear-gradient-85);}.cls-98{fill:url(#linear-gradient-86);}.cls-99{fill:url(#linear-gradient-87);}.cls-100{fill:url(#linear-gradient-88);}.cls-101{fill:#fff;}.cls-102{fill:url(#linear-gradient-89);}.cls-103{fill:#a3a5a8;}.cls-104{fill:url(#linear-gradient-90);}.cls-105{fill:url(#linear-gradient-91);}.cls-106{fill:url(#linear-gradient-92);}.cls-107{clip-path:url(#clip-path-2);}.cls-108{fill:url(#linear-gradient-93);}.cls-109{fill:url(#linear-gradient-94);}.cls-110{fill:url(#linear-gradient-95);}.cls-111{fill:url(#linear-gradient-96);}.cls-112{fill:url(#linear-gradient-97);}.cls-113{fill:url(#linear-gradient-98);}.cls-114{fill:url(#linear-gradient-99);}.cls-115{fill:url(#linear-gradient-100);}.cls-116{fill:url(#linear-gradient-101);}.cls-117{fill:url(#linear-gradient-102);}.cls-118{fill:url(#linear-gradient-103);}.cls-119{fill:url(#linear-gradient-104);}.cls-120{fill:url(#linear-gradient-105);}.cls-121{fill:url(#linear-gradient-106);}.cls-122{fill:url(#linear-gradient-107);}.cls-123{fill:url(#linear-gradient-108);}.cls-124{fill:url(#linear-gradient-109);}.cls-125{fill:url(#linear-gradient-110);}.cls-126{fill:url(#linear-gradient-111);}.cls-127{fill:url(#linear-gradient-112);}.cls-128{fill:url(#linear-gradient-113);}.cls-129{fill:url(#linear-gradient-114);}.cls-130{fill:url(#linear-gradient-115);}.cls-131{fill:url(#linear-gradient-116);}.cls-132{fill:url(#linear-gradient-117);}.cls-133{fill:url(#linear-gradient-118);}.cls-134{fill:url(#linear-gradient-119);}.cls-135{fill:url(#linear-gradient-120);}.cls-136{fill:url(#linear-gradient-121);}.cls-137{fill:url(#linear-gradient-122);}.cls-138{fill:url(#linear-gradient-123);}.cls-139{fill:url(#linear-gradient-124);}.cls-140{fill:url(#linear-gradient-125);}.cls-141{fill:url(#linear-gradient-126);}.cls-142{fill:url(#linear-gradient-127);}.cls-143{fill:url(#linear-gradient-128);}.cls-144{fill:url(#linear-gradient-129);}.cls-145{fill:url(#linear-gradient-130);}.cls-146{fill:url(#linear-gradient-131);}.cls-147{fill:url(#linear-gradient-132);}.cls-148{fill:url(#linear-gradient-133);}.cls-149{fill:url(#linear-gradient-134);}.cls-150{fill:url(#linear-gradient-135);}.cls-151{fill:url(#linear-gradient-136);}.cls-152{fill:url(#linear-gradient-137);}.cls-153{fill:url(#linear-gradient-138);}.cls-154{fill:url(#linear-gradient-139);}.cls-155{fill:url(#linear-gradient-140);}.cls-156{fill:url(#linear-gradient-141);}.cls-157{fill:url(#linear-gradient-142);}.cls-158{fill:url(#linear-gradient-143);}.cls-159{fill:url(#linear-gradient-144);}.cls-160{fill:url(#linear-gradient-145);}.cls-161{fill:url(#linear-gradient-146);}.cls-162{fill:url(#linear-gradient-147);}.cls-163{fill:url(#linear-gradient-148);}.cls-164{fill:url(#linear-gradient-149);}.cls-165{fill:url(#linear-gradient-150);}.cls-166{fill:url(#linear-gradient-151);}.cls-167{fill:url(#linear-gradient-152);}.cls-168{fill:url(#linear-gradient-153);}.cls-169{fill:url(#linear-gradient-154);}.cls-170{fill:url(#linear-gradient-155);}.cls-171{fill:url(#linear-gradient-156);}.cls-172{fill:url(#linear-gradient-157);}.cls-173{fill:url(#linear-gradient-158);}.cls-174{fill:url(#linear-gradient-159);}.cls-175{fill:url(#linear-gradient-160);}.cls-176{fill:url(#linear-gradient-161);}.cls-177{fill:url(#linear-gradient-162);}.cls-178{fill:url(#linear-gradient-163);}.cls-179{fill:url(#linear-gradient-164);}.cls-180{fill:url(#linear-gradient-165);}.cls-181{fill:url(#linear-gradient-166);}.cls-182{fill:url(#linear-gradient-167);}.cls-183{fill:url(#linear-gradient-168);}.cls-184{fill:url(#linear-gradient-169);}.cls-185{fill:url(#linear-gradient-170);}.cls-186{fill:url(#linear-gradient-171);}.cls-187{fill:url(#linear-gradient-172);}.cls-188{fill:url(#linear-gradient-173);}.cls-189{fill:url(#linear-gradient-174);}.cls-190{fill:url(#linear-gradient-175);}.cls-191{fill:url(#linear-gradient-176);}.cls-192{fill:url(#linear-gradient-177);}.cls-193{fill:url(#linear-gradient-178);}.cls-194{fill:url(#linear-gradient-179);}.cls-195{fill:url(#linear-gradient-180);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 46.68,
    y1: 21.52,
    x2: 91.68,
    y2: 21.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec1c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f181b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1462.45,
    y1: 74.19,
    x2: -1416.34,
    y2: 74.19,
    gradientTransform: "matrix(-1, 0, 0, 1, -1373.21, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 29.61,
    y1: 89.46,
    x2: 86.36,
    y2: 89.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.79,68l38.57,43-56.75-7V74.39A11.62,11.62,0,0,1,35.23,71C38.48,70.37,47.79,68,47.79,68Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 45.7,
    y1: 62.26,
    x2: 10.03,
    y2: 109.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 49.94,
    y1: 65.44,
    x2: 14.28,
    y2: 113.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 54.19,
    y1: 68.62,
    x2: 18.52,
    y2: 116.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 58.44,
    y1: 71.79,
    x2: 22.77,
    y2: 119.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 62.68,
    y1: 74.97,
    x2: 27.02,
    y2: 122.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 66.93,
    y1: 78.15,
    x2: 31.26,
    y2: 125.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 71.18,
    y1: 81.33,
    x2: 35.51,
    y2: 128.99,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 75.43,
    y1: 84.5,
    x2: 39.76,
    y2: 132.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 79.67,
    y1: 87.68,
    x2: 44.01,
    y2: 135.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 81.65,
    y1: 89.16,
    x2: 45.98,
    y2: 136.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 77.4,
    y1: 85.98,
    x2: 41.73,
    y2: 133.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 73.15,
    y1: 82.81,
    x2: 37.49,
    y2: 130.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 68.91,
    y1: 79.63,
    x2: 33.24,
    y2: 127.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 64.66,
    y1: 76.45,
    x2: 28.99,
    y2: 124.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 60.41,
    y1: 73.27,
    x2: 24.75,
    y2: 120.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 56.17,
    y1: 70.09,
    x2: 20.5,
    y2: 117.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 51.92,
    y1: 66.92,
    x2: 16.25,
    y2: 114.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 47.67,
    y1: 63.74,
    x2: 12.01,
    y2: 111.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 38.8,
    y1: 57.1,
    x2: 3.13,
    y2: 104.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 43.05,
    y1: 60.28,
    x2: 7.38,
    y2: 107.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 47.3,
    y1: 63.46,
    x2: 11.63,
    y2: 111.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 51.54,
    y1: 66.63,
    x2: 15.88,
    y2: 114.3,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 55.79,
    y1: 69.81,
    x2: 20.12,
    y2: 117.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 60.04,
    y1: 72.99,
    x2: 24.37,
    y2: 120.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 64.28,
    y1: 76.17,
    x2: 28.62,
    y2: 123.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 68.53,
    y1: 79.35,
    x2: 32.86,
    y2: 127.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 72.78,
    y1: 82.52,
    x2: 37.11,
    y2: 130.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 74.75,
    y1: 84,
    x2: 39.09,
    y2: 131.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 70.51,
    y1: 80.82,
    x2: 34.84,
    y2: 128.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 66.26,
    y1: 77.65,
    x2: 30.59,
    y2: 125.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 62.01,
    y1: 74.47,
    x2: 26.35,
    y2: 122.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 57.77,
    y1: 71.29,
    x2: 22.1,
    y2: 118.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 53.52,
    y1: 68.11,
    x2: 17.85,
    y2: 115.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 49.27,
    y1: 64.93,
    x2: 13.6,
    y2: 112.6,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 45.02,
    y1: 61.76,
    x2: 9.36,
    y2: 109.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 40.78,
    y1: 58.58,
    x2: 5.11,
    y2: 106.25,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 58.49,
    y1: 71.83,
    x2: 22.82,
    y2: 119.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 62.73,
    y1: 75.01,
    x2: 27.07,
    y2: 122.68,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 66.98,
    y1: 78.19,
    x2: 31.32,
    y2: 125.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 71.23,
    y1: 81.37,
    x2: 35.56,
    y2: 129.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 75.48,
    y1: 84.54,
    x2: 39.81,
    y2: 132.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 79.72,
    y1: 87.72,
    x2: 44.06,
    y2: 135.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 83.97,
    y1: 90.9,
    x2: 48.3,
    y2: 138.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 88.22,
    y1: 94.08,
    x2: 52.55,
    y2: 141.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 92.46,
    y1: 97.26,
    x2: 56.8,
    y2: 144.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 94.44,
    y1: 98.73,
    x2: 58.77,
    y2: 146.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 90.19,
    y1: 95.56,
    x2: 54.53,
    y2: 143.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 85.95,
    y1: 92.38,
    x2: 50.28,
    y2: 140.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 81.7,
    y1: 89.2,
    x2: 46.03,
    y2: 136.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 77.45,
    y1: 86.02,
    x2: 41.79,
    y2: 133.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 73.21,
    y1: 82.84,
    x2: 37.54,
    y2: 130.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 68.96,
    y1: 79.67,
    x2: 33.29,
    y2: 127.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 64.71,
    y1: 76.49,
    x2: 29.04,
    y2: 124.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 60.46,
    y1: 73.31,
    x2: 24.8,
    y2: 120.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 51.59,
    y1: 66.67,
    x2: 15.93,
    y2: 114.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 55.84,
    y1: 69.85,
    x2: 20.17,
    y2: 117.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 60.09,
    y1: 73.03,
    x2: 24.42,
    y2: 120.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 64.33,
    y1: 76.21,
    x2: 28.67,
    y2: 123.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 68.58,
    y1: 79.38,
    x2: 32.91,
    y2: 127.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 72.83,
    y1: 82.56,
    x2: 37.16,
    y2: 130.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 77.08,
    y1: 85.74,
    x2: 41.41,
    y2: 133.41,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 81.32,
    y1: 88.92,
    x2: 45.66,
    y2: 136.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 85.57,
    y1: 92.1,
    x2: 49.9,
    y2: 139.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 87.55,
    y1: 93.57,
    x2: 51.88,
    y2: 141.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 83.3,
    y1: 90.4,
    x2: 47.63,
    y2: 138.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 79.05,
    y1: 87.22,
    x2: 43.38,
    y2: 134.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 74.8,
    y1: 84.04,
    x2: 39.14,
    y2: 131.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 70.56,
    y1: 80.86,
    x2: 34.89,
    y2: 128.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 66.31,
    y1: 77.68,
    x2: 30.64,
    y2: 125.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 62.06,
    y1: 74.51,
    x2: 26.4,
    y2: 122.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 57.82,
    y1: 71.33,
    x2: 22.15,
    y2: 119,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 53.57,
    y1: 68.15,
    x2: 17.9,
    y2: 115.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 44.3,
    y1: 89.56,
    x2: 87.53,
    y2: 89.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec1c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#931417"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 80.02,
    y1: 16.18,
    x2: 52.62,
    y2: 18.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 87.66,
    y1: 65.65,
    x2: 51.41,
    y2: 69.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 87.95,
    y1: 68.1,
    x2: 51.7,
    y2: 72.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 88.21,
    y1: 70.36,
    x2: 51.96,
    y2: 74.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 88.47,
    y1: 72.61,
    x2: 52.23,
    y2: 76.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 88.65,
    y1: 74.02,
    x2: 52.39,
    y2: 78.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 88.76,
    y1: 74.98,
    x2: 52.51,
    y2: 79.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 88.79,
    y1: 75.26,
    x2: 52.54,
    y2: 79.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 88.75,
    y1: 74.93,
    x2: 52.5,
    y2: 79.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 88.64,
    y1: 73.97,
    x2: 52.38,
    y2: 78.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 88.48,
    y1: 72.59,
    x2: 52.23,
    y2: 76.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 88.17,
    y1: 70.02,
    x2: 51.92,
    y2: 74.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 73.49,
    y1: 46.05,
    x2: 79.13,
    y2: 46.05,
    gradientTransform: "matrix(1, 0, 0, -1, 42.47, 113.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb1b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 500.11,
    y1: -123.02,
    x2: 545.11,
    y2: -123.02,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: -1915.88,
    y1: -70.35,
    x2: -1869.77,
    y2: -70.35,
    gradientTransform: "matrix(1, 0, 0, -1, 1984.68, 74.93)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 483.04,
    y1: -55.09,
    x2: 539.78,
    y2: -55.09,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.25,151.52l-38.57-43,56.75,7v29.6a11.62,11.62,0,0,1-5.62,3.35C119.56,149.11,110.25,151.52,110.25,151.52Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 499.12,
    y1: -82.29,
    x2: 463.45,
    y2: -34.62,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 503.37,
    y1: -79.11,
    x2: 467.7,
    y2: -31.44,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 507.62,
    y1: -75.93,
    x2: 471.95,
    y2: -28.27,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 511.86,
    y1: -72.76,
    x2: 476.2,
    y2: -25.09,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 516.11,
    y1: -69.58,
    x2: 480.44,
    y2: -21.91,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 520.36,
    y1: -66.4,
    x2: 484.69,
    y2: -18.73,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 524.6,
    y1: -63.22,
    x2: 488.94,
    y2: -15.55,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 528.85,
    y1: -60.04,
    x2: 493.18,
    y2: -12.38,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 533.1,
    y1: -56.87,
    x2: 497.43,
    y2: -9.2,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 535.07,
    y1: -55.39,
    x2: 499.41,
    y2: -7.72,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 530.83,
    y1: -58.57,
    x2: 495.16,
    y2: -10.9,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 526.58,
    y1: -61.74,
    x2: 490.91,
    y2: -14.08,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 522.33,
    y1: -64.92,
    x2: 486.67,
    y2: -17.26,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 518.09,
    y1: -68.1,
    x2: 482.42,
    y2: -20.43,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 513.84,
    y1: -71.28,
    x2: 478.17,
    y2: -23.61,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 509.59,
    y1: -74.46,
    x2: 473.92,
    y2: -26.79,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 505.34,
    y1: -77.63,
    x2: 469.68,
    y2: -29.97,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 501.1,
    y1: -80.81,
    x2: 465.43,
    y2: -33.14,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 492.23,
    y1: -87.45,
    x2: 456.56,
    y2: -39.78,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 496.47,
    y1: -84.27,
    x2: 460.81,
    y2: -36.6,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 500.72,
    y1: -81.09,
    x2: 465.05,
    y2: -33.43,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 504.97,
    y1: -77.91,
    x2: 469.3,
    y2: -30.25,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 509.21,
    y1: -74.74,
    x2: 473.55,
    y2: -27.07,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 513.46,
    y1: -71.56,
    x2: 477.8,
    y2: -23.89,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 517.71,
    y1: -68.38,
    x2: 482.04,
    y2: -20.71,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 521.96,
    y1: -65.2,
    x2: 486.29,
    y2: -17.54,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 526.2,
    y1: -62.03,
    x2: 490.54,
    y2: -14.36,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 528.18,
    y1: -60.55,
    x2: 492.51,
    y2: -12.88,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 523.93,
    y1: -63.72,
    x2: 488.27,
    y2: -16.06,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 519.69,
    y1: -66.9,
    x2: 484.02,
    y2: -19.24,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 515.44,
    y1: -70.08,
    x2: 479.77,
    y2: -22.41,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 511.19,
    y1: -73.26,
    x2: 475.52,
    y2: -25.59,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 506.94,
    y1: -76.44,
    x2: 471.28,
    y2: -28.77,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 502.7,
    y1: -79.61,
    x2: 467.03,
    y2: -31.95,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 498.45,
    y1: -82.79,
    x2: 462.78,
    y2: -35.13,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 494.2,
    y1: -85.97,
    x2: 458.54,
    y2: -38.3,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 511.91,
    y1: -72.72,
    x2: 476.25,
    y2: -25.05,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 516.16,
    y1: -69.54,
    x2: 480.49,
    y2: -21.87,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 520.41,
    y1: -66.36,
    x2: 484.74,
    y2: -18.7,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 524.65,
    y1: -63.18,
    x2: 488.99,
    y2: -15.52,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 528.9,
    y1: -60.01,
    x2: 493.23,
    y2: -12.34,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 533.15,
    y1: -56.83,
    x2: 497.48,
    y2: -9.16,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 537.4,
    y1: -53.65,
    x2: 501.73,
    y2: -5.98,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 541.64,
    y1: -50.47,
    x2: 505.98,
    y2: -2.81,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 545.89,
    y1: -47.29,
    x2: 510.22,
    y2: 0.37,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 547.87,
    y1: -45.82,
    x2: 512.2,
    y2: 1.85,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 543.62,
    y1: -48.99,
    x2: 507.95,
    y2: -1.33,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 539.37,
    y1: -52.17,
    x2: 503.7,
    y2: -4.5,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 535.12,
    y1: -55.35,
    x2: 499.46,
    y2: -7.68,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 530.88,
    y1: -58.53,
    x2: 495.21,
    y2: -10.86,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 526.63,
    y1: -61.71,
    x2: 490.96,
    y2: -14.04,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 522.38,
    y1: -64.88,
    x2: 486.72,
    y2: -17.22,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 518.14,
    y1: -68.06,
    x2: 482.47,
    y2: -20.39,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 513.89,
    y1: -71.24,
    x2: 478.22,
    y2: -23.57,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 505.02,
    y1: -77.88,
    x2: 469.35,
    y2: -30.21,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 509.27,
    y1: -74.7,
    x2: 473.6,
    y2: -27.03,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 513.51,
    y1: -71.52,
    x2: 477.85,
    y2: -23.85,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 517.76,
    y1: -68.34,
    x2: 482.09,
    y2: -20.68,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 522.01,
    y1: -65.17,
    x2: 486.34,
    y2: -17.5,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 526.25,
    y1: -61.99,
    x2: 490.59,
    y2: -14.32,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 530.5,
    y1: -58.81,
    x2: 494.83,
    y2: -11.14,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 534.75,
    y1: -55.63,
    x2: 499.08,
    y2: -7.96,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 539,
    y1: -52.45,
    x2: 503.33,
    y2: -4.79,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 540.97,
    y1: -50.98,
    x2: 505.3,
    y2: -3.31,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 536.72,
    y1: -54.15,
    x2: 501.06,
    y2: -6.49,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 532.48,
    y1: -57.33,
    x2: 496.81,
    y2: -9.66,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 528.23,
    y1: -60.51,
    x2: 492.56,
    y2: -12.84,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 523.98,
    y1: -63.69,
    x2: 488.32,
    y2: -16.02,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 519.74,
    y1: -66.86,
    x2: 484.07,
    y2: -19.2,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 515.49,
    y1: -70.04,
    x2: 479.82,
    y2: -22.38,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 511.24,
    y1: -73.22,
    x2: 475.57,
    y2: -25.55,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 506.99,
    y1: -76.4,
    x2: 471.33,
    y2: -28.73,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 497.73,
    y1: -54.99,
    x2: 540.95,
    y2: -54.99,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-76"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 533.45,
    y1: -128.37,
    x2: 506.05,
    y2: -126.54,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 541.09,
    y1: -78.9,
    x2: 504.84,
    y2: -74.65,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 541.38,
    y1: -76.45,
    x2: 505.12,
    y2: -72.2,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 541.64,
    y1: -74.19,
    x2: 505.39,
    y2: -69.94,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 541.9,
    y1: -71.94,
    x2: 505.65,
    y2: -67.69,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 542.07,
    y1: -70.53,
    x2: 505.82,
    y2: -66.28,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 542.18,
    y1: -69.57,
    x2: 505.93,
    y2: -65.32,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 542.21,
    y1: -69.29,
    x2: 505.96,
    y2: -65.04,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 542.17,
    y1: -69.62,
    x2: 505.92,
    y2: -65.37,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 542.06,
    y1: -70.58,
    x2: 505.81,
    y2: -66.33,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 541.9,
    y1: -71.96,
    x2: 505.65,
    y2: -67.71,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 541.6,
    y1: -74.53,
    x2: 505.35,
    y2: -70.28,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 569.95,
    y1: -161.52,
    x2: 510.6,
    y2: -82.2,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 531.27,
    y1: -146.45,
    x2: 495.6,
    y2: -98.78,
    gradientTransform: "translate(611.47 74.93) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 526.92,
    y1: 190.6,
    x2: 532.56,
    y2: 190.6,
    gradientTransform: "matrix(-1, 0, 0, 1, 569, -38.48)",
    xlinkHref: "#linear-gradient-89"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1576.94,
    y: -519.25,
    width: 2406.31,
    height: 1210.9
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(2.52 1.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACcElEQVR4Xu3WMQqEMABFwUT2/lfOVgqKsAv6upnOaPn4ca61xo3bQ/jDvB58Ls/i4qm9oSO27eYlvOHoaY9MYBTWGOclg8Q2rBitZcnIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYzcNsaYvz6CB6YlI7dHZs0ozDHO/2RC401HT9frUmi84dTRFxMoDbIIDQHrAAAAAElFTkSuQmCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.18,12.44v-.6h9.37v.6h-.79a2.31,2.31,0,0,0-2,.79,4.89,4.89,0,0,0-.38,2.48v10.7a12.2,12.2,0,0,1-.55,4A6.12,6.12,0,0,1,21,33.07a4.71,4.71,0,0,1-3.19,1.14,3.55,3.55,0,0,1-2.39-.75,2.22,2.22,0,0,1-.87-1.72,1.66,1.66,0,0,1,.4-1.19,1.79,1.79,0,0,1,1.25-.5,1.38,1.38,0,0,1,.92.34,5.34,5.34,0,0,1,1,1.8c.25.59.57.88,1,.88a1,1,0,0,0,.81-.54,3.41,3.41,0,0,0,.38-1.88V15.71a7.26,7.26,0,0,0-.21-2.19,1.45,1.45,0,0,0-.68-.69A2.94,2.94,0,0,0,18,12.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.86,207v.6h-9.37V207h.79a2.31,2.31,0,0,0,1.95-.79,4.86,4.86,0,0,0,.39-2.48v-10.7a12.23,12.23,0,0,1,.54-4,6.12,6.12,0,0,1,1.86-2.67,4.73,4.73,0,0,1,3.19-1.14,3.55,3.55,0,0,1,2.39.75,2.22,2.22,0,0,1,.87,1.72,1.62,1.62,0,0,1-.4,1.19,1.78,1.78,0,0,1-1.24.5,1.39,1.39,0,0,1-.93-.34,5.34,5.34,0,0,1-1-1.8c-.25-.58-.57-.88-1-.88a1.06,1.06,0,0,0-.82.54,3.41,3.41,0,0,0-.38,1.88v14.94a7.22,7.22,0,0,0,.21,2.19,1.45,1.45,0,0,0,.68.69,2.94,2.94,0,0,0,1.47.39Z"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 15,
    transform: "translate(13.52 39.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAACXBIWXMAAAsSAAALEgHS3X78AAABjklEQVQoU22S3VLUUBCEv5lzkuxCsXhhlZaAeuE7oLKPL/oSQKmsuKJVsEk2m5xfL4IriH05M901M92Scwbg9MVRBuHk6qtwDx+eH2aA+XIhAJJz5uPhq2wqCwKx96SQAChnE5KPiAqh85x8vxQ5PTjKprLYaYlYxTc9okr1ZELOkHzEtwOhD4iAigpaGLhbpNgtcU2PWKWcVewe7FPOJqhVAGx0ETsFOy3QQlFr8J1n59keySeKvYocE4iwvlphAUQFtYrdKVGr7L95+nd/q2hhUKuUs8lISCGCCGrHhplY1BoQYXPdsvnV4uoeV/coQE4Z1/QMNx1aGbQwpJSILiAKw81mvBPQ+XIhfu0Ia0foHL4ZGN+T8XWPq4dR8HbDfLkQ/WNKCgkxOg7kzLDq6X60dNcNosL7xWio3hnKuy+fxTUDyUfcakAEumVN8onjs/Ot+1sCwPHZufi1Q1Rov61IIfH24uJBVB4QAHwzsPnZ0l7eouZRe8zSv/j08nWOLmwDdx+PJYDowv/KAPwGQsnOB5ofH6sAAAAASUVORK5CYII="
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 14,
    transform: "translate(132.52 166.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAAsSAAALEgHS3X78AAABcElEQVQoU22S0Y7SUBCGvzmnPW2hULhQm7WIF8Z32MTHR0x8Cje7ieIVLqRA2zPjBaJhcS7nny/zz58RM+NlrZt3poPy6ceTvNTczTRgBvl89D/pFvh8tzCLSjYv+Prxw836K+DL8r2JE8rFjFAVhGnOerG8gv4C62ZpLnGM6inl24pQZYgT0jKwbv5BDmBVN+aCZ3xXUbwaE6Y5AKM3E3zq8ZlnVTd2tQE1TI0wK0AEcQ4XPOkkR7xD3DmwZFU3FqqcMM3JZjlJniIixGOPDkpaBrAxLnGs6sYSgKwqKF6XZPMC7SPihG5/QpxgUc8O/lyRJHnKcOjBDO0V7SMWlePPPekkR4eImV3mcdpHXOrRQTltD8RuAGD3uCWeBoa2x6IRTwM+eJxGpd3s2D/9AjUOmz3tZgdA+/0Z4OxADRCSS0Ld9sC27XCpp3s+AtC3HZKcgzRVYheRy/Ot6saSIsXUuH/4JpcegE89948PAvAbdhan8lRsJCQAAAAASUVORK5CYII="
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.6,65.79,35.23,71.15s-5.62.53-5.62,7.23V104.1l99.6,11.52S104.09,78.11,96.26,71.41c-.88-.75-4.92-1.63-9.88-2.48C76.73,67.28,63.6,65.79,63.6,65.79Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M69.8,27.77l19.74,1.57L89,31.53l2.49,13.76L88.8,46l.38,3.12-2.3,1.47.19,1.78S84.51,53.44,86,55s2.8,4.4-4.3,4.8c-4.32.24-6.52,2.25-2.9,8.44,0-.58-3,4-7.66,4.29C64,72.9,54,69.28,54,69.28S69.46,33.51,69.8,27.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.53,31.85a2.3,2.3,0,0,1-1.23,2.92,12.87,12.87,0,0,1-2.76-.84c-1.62-.66-5.16-.22-5.65.35s1-3.29,6.63-1.61C89,33.7,88.53,31.85,88.53,31.85Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.57,35.26a6,6,0,0,1-3.26-.08c-1.61-.55-3.85-.43-4.92.57a9.16,9.16,0,0,1,4.29.28s-.55,2,.67,2.2,1.29-2,1.29-2A3.17,3.17,0,0,0,87.57,35.26Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.12,27.23S72,50.61,74.22,56.16c0,0,6.22,14.21-26.3,8.63,0,0-2.54-6.1,3.51-7.08,0,0-4.3-31.24.58-30.44Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M47.92,64.79s-4.44-10.17,22.87-7.44C70.79,57.35,42.4,52.81,47.92,64.79Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.39,28.09s.23,20.13.93,29c0,0-4.36-18.9-3-28.87Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M66.24,27.63A91.65,91.65,0,0,0,66.75,55S62.62,40.42,64.6,27.74Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.61,26.51a91.24,91.24,0,0,0,.51,27.33S54,39.29,56,26.62Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M64,57.16S56.27,62,63.32,65.6C63.32,65.6,58.07,62.21,64,57.16Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M56.43,57.14S48.7,62,55.76,65.58C55.76,65.58,50.51,62.19,56.43,57.14Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.18,28.81a185,185,0,0,1,38.67.71L91.68,15.3S83,11.57,78.35,14.94c0,0-5.33,2.67-8.5,1.42s-5-3.91-9.67-2.31-9.5,8.72-13.5,8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.85,30s15.66-2.5,39.33.17l.17-2.5S66,24.52,49.18,27.35Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M77.6,66.85l11.64,2.62S87.91,81.12,71.07,81.53,43.14,69.07,43.14,69.07l11.21-2s8,6.66,16.25,5.25S77.6,66.85,77.6,66.85Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M47.79,68l38.57,43-56.75-7V74.39A11.62,11.62,0,0,1,35.23,71C38.48,70.37,47.79,68,47.79,68Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M32.41,82a4.56,4.56,0,0,1,.67,1.12l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.32.14-.37A4.65,4.65,0,0,1,34.11,82c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.23,2.23,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.31,1.31,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C30.65,80.36,31.64,81,32.41,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39,82a4.25,4.25,0,0,1,.66,1.12,2,2,0,0,1,.12.34c0,.09.06.14.08.14s0,0,0,0a0,0,0,0,0,0,0c.06,0,.12-.32.13-.37A5.28,5.28,0,0,1,40.73,82c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.34,1.34,0,0,0-1.1.69,2.24,2.24,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.35,1.35,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C37.28,80.36,38.27,81,39,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M45.66,82a4.56,4.56,0,0,1,.67,1.12l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.32.14-.37A4.65,4.65,0,0,1,47.36,82c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.23,2.23,0,0,0-.29.76A1.61,1.61,0,0,0,45,76.87a1.31,1.31,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C43.9,80.36,44.89,81,45.66,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M52.29,82A4.25,4.25,0,0,1,53,83.14a2,2,0,0,1,.12.34c0,.09.06.14.08.14s0,0,0,0a0,0,0,0,0,0,0c.06,0,.12-.32.13-.37A5.28,5.28,0,0,1,54,82c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.34,1.34,0,0,0-1.1.69,2.24,2.24,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.35,1.35,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C50.53,80.36,51.52,81,52.29,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M58.91,82a4.56,4.56,0,0,1,.67,1.12l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.32.14-.37A4.65,4.65,0,0,1,60.61,82c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.23,2.23,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.31,1.31,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C57.15,80.36,58.14,81,58.91,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M65.54,82a4.25,4.25,0,0,1,.66,1.12,2,2,0,0,1,.12.34c0,.09.06.14.08.14l0,0a0,0,0,0,0,0,0c.06,0,.12-.32.13-.37A5.28,5.28,0,0,1,67.23,82c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.34,1.34,0,0,0-1.1.69,2.24,2.24,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.35,1.35,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C63.78,80.36,64.77,81,65.54,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M72.16,82a4.56,4.56,0,0,1,.67,1.12l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.32.14-.37A4.65,4.65,0,0,1,73.86,82c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.23,2.23,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.31,1.31,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C70.4,80.36,71.39,81,72.16,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M78.79,82a4.25,4.25,0,0,1,.66,1.12,2,2,0,0,1,.12.34c0,.09.06.14.08.14l0,0a0,0,0,0,0,0,0c.06,0,.12-.32.13-.37A5.28,5.28,0,0,1,80.48,82c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.34,1.34,0,0,0-1.1.69,2.24,2.24,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.35,1.35,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C77,80.36,78,81,78.79,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M85.41,82a4.56,4.56,0,0,1,.67,1.12l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.32.14-.37A4.65,4.65,0,0,1,87.11,82c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.23,2.23,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.31,1.31,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C83.65,80.36,84.64,81,85.41,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M84.19,83.76a4.31,4.31,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1-.05-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.74a2.27,2.27,0,0,0,.49,2A1.27,1.27,0,0,0,82,89a1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C86,85.41,85,84.76,84.19,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M77.56,83.76a4.6,4.6,0,0,1-.66-1.13c0-.1-.08-.22-.12-.33s0-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.74a2.26,2.26,0,0,0,.48,2,1.3,1.3,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.26,1.26,0,0,0,1-.49,2.25,2.25,0,0,0,.41-2C79.33,85.41,78.34,84.76,77.56,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M70.94,83.76a4.31,4.31,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1-.05-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.74a2.27,2.27,0,0,0,.49,2,1.27,1.27,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C72.7,85.41,71.71,84.76,70.94,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M64.31,83.76a4.6,4.6,0,0,1-.66-1.13c0-.1-.08-.22-.12-.33s-.05-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.74a2.26,2.26,0,0,0,.48,2,1.3,1.3,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76A1.6,1.6,0,0,0,65,88.9a1.26,1.26,0,0,0,1-.49,2.25,2.25,0,0,0,.41-2C66.08,85.41,65.09,84.76,64.31,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M57.69,83.76A4.31,4.31,0,0,1,57,82.63a3.24,3.24,0,0,1-.13-.33c0-.1,0-.14-.07-.14h0c-.06,0-.12.31-.14.37A4.6,4.6,0,0,1,56,83.79c-.73,1-1.69,1.72-1.93,2.74a2.27,2.27,0,0,0,.49,2,1.27,1.27,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C59.45,85.41,58.46,84.76,57.69,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M51.06,83.76a4.6,4.6,0,0,1-.66-1.13c0-.1-.08-.22-.12-.33s-.05-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.74a2.26,2.26,0,0,0,.48,2,1.3,1.3,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.25,2.25,0,0,0,.41-2C52.83,85.41,51.84,84.76,51.06,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M44.44,83.76a4.31,4.31,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1,0-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.74a2.27,2.27,0,0,0,.49,2,1.27,1.27,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C46.2,85.41,45.21,84.76,44.44,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M37.81,83.76a4.6,4.6,0,0,1-.66-1.13c0-.1-.08-.22-.12-.33s-.05-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.74a2.26,2.26,0,0,0,.48,2,1.3,1.3,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.25,2.25,0,0,0,.41-2C39.58,85.41,38.59,84.76,37.81,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M31.19,83.76a4.31,4.31,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1,0-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.6,4.6,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.74a2.27,2.27,0,0,0,.49,2A1.27,1.27,0,0,0,29,89a1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C33,85.41,32,84.76,31.19,83.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M31.78,68.48a5,5,0,0,1,.67,1.13l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C30,66.83,31,67.49,31.78,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M38.41,68.48a4.66,4.66,0,0,1,.66,1.13,2,2,0,0,1,.12.34c0,.09.06.14.08.14l0,0s0,0,0,0,.11-.31.13-.36a5,5,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.34,1.34,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C36.64,66.83,37.64,67.49,38.41,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M45,68.48a5,5,0,0,1,.67,1.13l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C43.27,66.83,44.26,67.49,45,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M51.66,68.48a4.66,4.66,0,0,1,.66,1.13,2,2,0,0,1,.12.34c0,.09.06.14.08.14l0,0s0,0,0,0,.11-.31.13-.36a5,5,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.34,1.34,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76A1.61,1.61,0,0,0,51,63.34a1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C49.89,66.83,50.89,67.49,51.66,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M58.28,68.48A5,5,0,0,1,59,69.61l.12.34c0,.09,0,.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.36A4.65,4.65,0,0,1,60,68.45c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C56.52,66.83,57.51,67.49,58.28,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M64.91,68.48a4.66,4.66,0,0,1,.66,1.13,2,2,0,0,1,.12.34c0,.09.06.14.08.14l0,0s0,0,0,0,.11-.31.13-.36a5,5,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45A1.34,1.34,0,0,0,66,64a2.32,2.32,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C63.14,66.83,64.14,67.49,64.91,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M71.53,68.48a5,5,0,0,1,.67,1.13l.12.34c0,.09.05.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C69.77,66.83,70.76,67.49,71.53,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M78.16,68.48a4.66,4.66,0,0,1,.66,1.13,2,2,0,0,1,.12.34c0,.09.06.14.08.14l0,0s0,0,0,0,.11-.31.13-.36a5,5,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.34,1.34,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C76.39,66.83,77.39,67.49,78.16,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M84.78,68.48a5,5,0,0,1,.67,1.13l.12.34c0,.09.05.14.07.14a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.35,1.35,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C83,66.83,84,67.49,84.78,68.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M83.56,70.23a4.48,4.48,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1,0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.46,4.46,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.49,2,1.29,1.29,0,0,0,1,.45,1.37,1.37,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.59,1.59,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C85.32,71.88,84.33,71.23,83.56,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M76.93,70.23a4.8,4.8,0,0,1-.66-1.13,3.21,3.21,0,0,1-.12-.33c0-.1-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37a4.73,4.73,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.29,2.29,0,0,0,.48,2,1.33,1.33,0,0,0,1,.45,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.59,1.59,0,0,0,1.45,1.39,1.26,1.26,0,0,0,1-.49,2.28,2.28,0,0,0,.41-2C78.7,71.88,77.71,71.23,76.93,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M70.31,70.23a4.48,4.48,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1,0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.46,4.46,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.49,2,1.29,1.29,0,0,0,1,.45,1.37,1.37,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76A1.59,1.59,0,0,0,71,75.37a1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C72.07,71.88,71.08,71.23,70.31,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M63.68,70.23A4.8,4.8,0,0,1,63,69.1a3.21,3.21,0,0,1-.12-.33c0-.1-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37A4.73,4.73,0,0,1,62,70.26c-.74,1-1.7,1.72-1.93,2.73a2.29,2.29,0,0,0,.48,2,1.33,1.33,0,0,0,1,.45,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.59,1.59,0,0,0,1.45,1.39,1.26,1.26,0,0,0,1-.49,2.28,2.28,0,0,0,.41-2C65.45,71.88,64.46,71.23,63.68,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M57.06,70.23a4.48,4.48,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1-.05-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.46,4.46,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.49,2,1.29,1.29,0,0,0,1,.45,1.37,1.37,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.59,1.59,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C58.82,71.88,57.83,71.23,57.06,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M50.43,70.23a4.8,4.8,0,0,1-.66-1.13,3.21,3.21,0,0,1-.12-.33c0-.1-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37a4.73,4.73,0,0,1-.66,1.26C48,71.29,47,72,46.81,73a2.29,2.29,0,0,0,.48,2,1.33,1.33,0,0,0,1,.45,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.59,1.59,0,0,0,1.45,1.39,1.26,1.26,0,0,0,1-.49,2.28,2.28,0,0,0,.41-2C52.2,71.88,51.21,71.23,50.43,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M43.81,70.23a4.48,4.48,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1-.05-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.46,4.46,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.49,2,1.29,1.29,0,0,0,1,.45,1.37,1.37,0,0,0,1.1-.69A2.11,2.11,0,0,0,43,74a1.59,1.59,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.26,2.26,0,0,0,.42-2C45.57,71.88,44.58,71.23,43.81,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M37.18,70.23a4.8,4.8,0,0,1-.66-1.13,3.21,3.21,0,0,1-.12-.33c0-.1-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37a4.73,4.73,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73A2.29,2.29,0,0,0,34,75a1.33,1.33,0,0,0,1,.45,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.59,1.59,0,0,0,1.45,1.39,1.26,1.26,0,0,0,1-.49,2.28,2.28,0,0,0,.41-2C39,71.88,38,71.23,37.18,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M30.56,70.23a4.48,4.48,0,0,1-.66-1.13,3.24,3.24,0,0,1-.13-.33c0-.1-.05-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.46,4.46,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.49,2,1.29,1.29,0,0,0,1,.45,1.37,1.37,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.59,1.59,0,0,0,1.45,1.39,1.24,1.24,0,0,0,.95-.49,2.26,2.26,0,0,0,.42-2C32.32,71.88,31.33,71.23,30.56,70.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M32.41,108.68a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C30.65,107,31.64,107.69,32.41,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M39,108.68a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.12-.31.13-.36a5.28,5.28,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C37.28,107,38.27,107.69,39,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M45.66,108.68a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C43.9,107,44.89,107.69,45.66,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M52.29,108.68a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.12-.31.13-.36a5.28,5.28,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C50.53,107,51.52,107.69,52.29,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M58.91,108.68a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C57.15,107,58.14,107.69,58.91,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M65.54,108.68a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.12-.31.13-.36a5.28,5.28,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C63.78,107,64.77,107.69,65.54,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M72.16,108.68a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C70.4,107,71.39,107.69,72.16,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M78.79,108.68a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.12-.31.13-.36a5.28,5.28,0,0,1,.66-1.27c.74-1,1.7-1.72,1.94-2.73a2.32,2.32,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.61,1.61,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C77,107,78,107.69,78.79,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M85.41,108.68a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.36a4.65,4.65,0,0,1,.66-1.27c.73-1,1.7-1.72,1.93-2.73a2.26,2.26,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C83.65,107,84.64,107.69,85.41,108.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M84.19,110.43a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s-.05-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C86,112.08,85,111.43,84.19,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M77.56,110.43a4.8,4.8,0,0,1-.66-1.13l-.12-.33c0-.1,0-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.26,1.26,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C79.33,112.08,78.34,111.43,77.56,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M70.94,110.43a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s-.05-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C72.7,112.08,71.71,111.43,70.94,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M64.31,110.43a4.8,4.8,0,0,1-.66-1.13l-.12-.33c0-.1-.05-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76A1.6,1.6,0,0,0,65,115.57a1.26,1.26,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C66.08,112.08,65.09,111.43,64.31,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M57.69,110.43A4.48,4.48,0,0,1,57,109.3c-.05-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C59.45,112.08,58.46,111.43,57.69,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M51.06,110.43a4.8,4.8,0,0,1-.66-1.13l-.12-.33c0-.1-.05-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.27,2.27,0,0,0,.41-2C52.83,112.08,51.84,111.43,51.06,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M44.44,110.43a4.48,4.48,0,0,1-.66-1.13c-.05-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C46.2,112.08,45.21,111.43,44.44,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M37.81,110.43a4.8,4.8,0,0,1-.66-1.13L37,109c0-.1-.05-.14-.08-.14a0,0,0,0,0,0,0h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.27,2.27,0,0,0,.41-2C39.58,112.08,38.59,111.43,37.81,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M31.19,110.43a4.48,4.48,0,0,1-.66-1.13c-.05-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.11,2.11,0,0,0,.29-.76,1.6,1.6,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C33,112.08,32,111.43,31.19,110.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M31.78,95.15a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2A1.26,1.26,0,0,0,34,90a1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75A1.61,1.61,0,0,0,31.11,90a1.28,1.28,0,0,0-.95.49,2.24,2.24,0,0,0-.41,2C30,93.5,31,94.15,31.78,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M38.41,95.15a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.05,5.05,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75A1.61,1.61,0,0,0,37.74,90a1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C36.64,93.5,37.64,94.15,38.41,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M45,95.15a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75A1.61,1.61,0,0,0,44.36,90a1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C43.27,93.5,44.26,94.15,45,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M51.66,95.15a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.05,5.05,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75A1.61,1.61,0,0,0,51,90a1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C49.89,93.5,50.89,94.15,51.66,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M58.28,95.15A4.82,4.82,0,0,1,59,96.28l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37A4.74,4.74,0,0,1,60,95.12c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75A1.61,1.61,0,0,0,57.61,90a1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C56.52,93.5,57.51,94.15,58.28,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M64.91,95.15a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.05,5.05,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75A1.61,1.61,0,0,0,64.24,90a1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C63.14,93.5,64.14,94.15,64.91,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M71.53,95.15a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1.05.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75A1.61,1.61,0,0,0,70.86,90a1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C69.77,93.5,70.76,94.15,71.53,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M78.16,95.15a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.05,5.05,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75A1.61,1.61,0,0,0,77.49,90a1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C76.39,93.5,77.39,94.15,78.16,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M84.78,95.15a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1.05.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2A1.26,1.26,0,0,0,87,90a1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75A1.61,1.61,0,0,0,84.11,90a1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C83,93.5,84,94.15,84.78,95.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M83.56,96.9a4.48,4.48,0,0,1-.66-1.13c-.05-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.33,1.33,0,0,0,1.1-.69,2,2,0,0,0,.29-.75A1.61,1.61,0,0,0,84.23,102a1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C85.32,98.55,84.33,97.9,83.56,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M76.93,96.9a4.8,4.8,0,0,1-.66-1.13c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37a5.05,5.05,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.39,2.39,0,0,0,.29-.75A1.61,1.61,0,0,0,77.61,102a1.29,1.29,0,0,0,1-.49,2.31,2.31,0,0,0,.41-2C78.7,98.55,77.71,97.9,76.93,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M70.31,96.9a4.48,4.48,0,0,1-.66-1.13c-.05-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.33,1.33,0,0,0,1.1-.69,2,2,0,0,0,.29-.75A1.61,1.61,0,0,0,71,102a1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C72.07,98.55,71.08,97.9,70.31,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M63.68,96.9A4.8,4.8,0,0,1,63,95.77c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37A5.05,5.05,0,0,1,62,96.93c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.39,2.39,0,0,0,.29-.75A1.61,1.61,0,0,0,64.36,102a1.29,1.29,0,0,0,1-.49,2.31,2.31,0,0,0,.41-2C65.45,98.55,64.46,97.9,63.68,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M57.06,96.9a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s-.05-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.33,1.33,0,0,0,1.1-.69,2,2,0,0,0,.29-.75A1.61,1.61,0,0,0,57.73,102a1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C58.82,98.55,57.83,97.9,57.06,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M50.43,96.9a4.8,4.8,0,0,1-.66-1.13c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37a5.05,5.05,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.39,2.39,0,0,0,.29-.75A1.61,1.61,0,0,0,51.11,102a1.29,1.29,0,0,0,1-.49,2.31,2.31,0,0,0,.41-2C52.2,98.55,51.21,97.9,50.43,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M43.81,96.9a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33S43,95.3,43,95.3h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.33,1.33,0,0,0,1.1-.69,2,2,0,0,0,.29-.75A1.61,1.61,0,0,0,44.48,102a1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C45.57,98.55,44.58,97.9,43.81,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M37.18,96.9a4.8,4.8,0,0,1-.66-1.13c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14a0,0,0,0,0,0,0h0c-.06,0-.11.31-.13.37a5.05,5.05,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.39,2.39,0,0,0,.29-.75A1.61,1.61,0,0,0,37.86,102a1.29,1.29,0,0,0,1-.49,2.31,2.31,0,0,0,.41-2C39,98.55,38,97.9,37.18,96.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M30.56,96.9a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s-.05-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.33,1.33,0,0,0,1.1-.69,2,2,0,0,0,.29-.75A1.61,1.61,0,0,0,31.23,102a1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C32.32,98.55,31.33,97.9,30.56,96.9Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "48.96 68.06 87.53 111.06 80.65 110.26 44.3 69.07 48.96 68.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "44.3 69.07 35.22 71.28 65.36 108.25 80.65 110.26 44.3 69.07"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "48.96 68.06 47.63 72.89 55.61 75.7 56.79 83.07 64.32 85.21 64.92 92.31 72.6 94.32 74.08 102.35 80.43 103.16 48.96 68.06"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M46.68,22.05c.55.07,2.38,2.51,9-3.48s9.29-.49,15.16-.73,11-6.06,20.85-2.54c0,0-8.37-4.32-20.72.46,0,0-1.47.12-3.31-2s-8.31-.61-14.18,4.28S46.68,22.05,46.68,22.05Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M71.81,108.63a4.93,4.93,0,0,1,1.3.49l.32.19c.09.06.14.08.16.07v0h0s-.11-.33-.13-.39a5.06,5.06,0,0,1-.3-1.48c-.07-1.34.26-2.55-.22-3.55a2.4,2.4,0,0,0-1.72-1.31,1.37,1.37,0,0,0-1.1.27,1.46,1.46,0,0,0-.45,1.31A2.37,2.37,0,0,0,70,105a1.7,1.7,0,0,0-2.12-.19,1.35,1.35,0,0,0-.46,1,2.39,2.39,0,0,0,1,1.92C69.26,108.44,70.51,108.32,71.81,108.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M67.16,103.16a4.87,4.87,0,0,1,1.29.49l.33.2c.09.06.13.08.15.06s0,0,0,0h0c.06,0-.1-.34-.13-.4a5,5,0,0,1-.29-1.48c-.08-1.34.26-2.55-.22-3.54a2.42,2.42,0,0,0-1.72-1.31,1.35,1.35,0,0,0-1.11.27,1.43,1.43,0,0,0-.44,1.3,2.37,2.37,0,0,0,.26.82,1.7,1.7,0,0,0-2.12-.19,1.36,1.36,0,0,0-.47,1,2.44,2.44,0,0,0,1,1.92C64.6,103,65.86,102.85,67.16,103.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M62.5,97.69a5.58,5.58,0,0,1,1.3.49l.32.2c.09.06.14.08.16.07s0,0,0,0h0s-.11-.34-.13-.4a4.93,4.93,0,0,1-.3-1.48c-.07-1.33.26-2.55-.22-3.54A2.4,2.4,0,0,0,62,91.69a1.38,1.38,0,0,0-1.11.27,1.44,1.44,0,0,0-.45,1.3,2.31,2.31,0,0,0,.26.82,1.71,1.71,0,0,0-2.12-.19,1.37,1.37,0,0,0-.46,1,2.41,2.41,0,0,0,1,1.93C60,97.5,61.2,97.39,62.5,97.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M57.85,92.23a4.93,4.93,0,0,1,1.3.49l.32.19c.09.06.14.08.15.07s0,0,0,0h0c.05,0-.11-.33-.14-.39a5.39,5.39,0,0,1-.29-1.49c-.08-1.33.26-2.54-.22-3.54a2.44,2.44,0,0,0-1.72-1.31,1.37,1.37,0,0,0-1.1.27,1.46,1.46,0,0,0-.45,1.31,2.37,2.37,0,0,0,.26.82,1.7,1.7,0,0,0-2.12-.19,1.35,1.35,0,0,0-.46,1,2.41,2.41,0,0,0,1,1.92C55.3,92,56.55,91.92,57.85,92.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M53.2,86.76a4.87,4.87,0,0,1,1.29.49l.33.2q.12.09.15.06s0,0,0,0h0s-.11-.34-.13-.4a5.06,5.06,0,0,1-.3-1.48c-.07-1.34.26-2.55-.21-3.54a2.42,2.42,0,0,0-1.72-1.31,1.35,1.35,0,0,0-1.11.27,1.43,1.43,0,0,0-.45,1.3,2.4,2.4,0,0,0,.27.82A1.71,1.71,0,0,0,49.22,83a1.37,1.37,0,0,0-.46,1,2.44,2.44,0,0,0,1,1.92C50.64,86.57,51.9,86.45,53.2,86.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M48.54,81.29a5.35,5.35,0,0,1,1.3.5,3.37,3.37,0,0,1,.32.19c.09.06.14.08.16.07v0a0,0,0,0,0,0,0s-.11-.34-.13-.4a4.93,4.93,0,0,1-.3-1.48c-.07-1.33.26-2.55-.22-3.54A2.4,2.4,0,0,0,48,75.29a1.37,1.37,0,0,0-1.1.27,1.44,1.44,0,0,0-.45,1.3,2.42,2.42,0,0,0,.26.83,1.7,1.7,0,0,0-2.12-.2,1.37,1.37,0,0,0-.46,1,2.39,2.39,0,0,0,1,1.93C46,81.1,47.24,81,48.54,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M43.89,75.83a4.93,4.93,0,0,1,1.3.49l.32.19c.09.06.14.08.15.07s0,0,0,0,0,0,0,0-.1-.33-.13-.39a5,5,0,0,1-.29-1.48c-.08-1.34.26-2.55-.22-3.55a2.44,2.44,0,0,0-1.72-1.31,1.36,1.36,0,0,0-1.1.28,1.41,1.41,0,0,0-.45,1.3,2.37,2.37,0,0,0,.26.82A1.7,1.7,0,0,0,39.92,72a1.36,1.36,0,0,0-.47,1,2.44,2.44,0,0,0,1,1.92C41.33,75.64,42.59,75.52,43.89,75.83Z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M50.05,70.76a3,3,0,0,1-.14.7,1.34,1.34,0,0,1-.07.18s0,.08,0,.08,0,0,0,0v0s.15-.08.18-.1a2.08,2.08,0,0,1,.68-.26c.62-.14,1.22-.06,1.65-.39a1.25,1.25,0,0,0,.5-1,.73.73,0,0,0-.21-.54.64.64,0,0,0-.64-.13,1,1,0,0,0-.37.19.91.91,0,0,0-.06-1.09.59.59,0,0,0-.52-.16,1.15,1.15,0,0,0-.84.65A5.43,5.43,0,0,0,50.05,70.76Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M53.14,73a2.43,2.43,0,0,1,0,.71l0,.19c0,.06,0,.08,0,.09h0s0,0,0,0,.13-.11.16-.13a2.51,2.51,0,0,1,.61-.41c.59-.27,1.19-.32,1.55-.72a1.29,1.29,0,0,0,.31-1.07.7.7,0,0,0-.3-.48.63.63,0,0,0-.66,0,1.12,1.12,0,0,0-.32.27.93.93,0,0,0-.26-1.07.6.6,0,0,0-.54,0,1.21,1.21,0,0,0-.7.82A5.47,5.47,0,0,0,53.14,73Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M56.21,74.91a3.39,3.39,0,0,1,0,.71c0,.07,0,.13,0,.2s0,.08,0,.08h0s.14-.11.16-.13a2.13,2.13,0,0,1,.62-.4c.58-.27,1.18-.32,1.55-.73a1.35,1.35,0,0,0,.31-1.06.72.72,0,0,0-.3-.49.65.65,0,0,0-.66,0,.91.91,0,0,0-.32.27.93.93,0,0,0-.26-1.06.6.6,0,0,0-.54,0,1.23,1.23,0,0,0-.71.81A5.45,5.45,0,0,0,56.21,74.91Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M59.58,76.92a2.29,2.29,0,0,1,.22.67.63.63,0,0,1,0,.19c0,.06,0,.08,0,.09h0s.09-.15.11-.18a2.71,2.71,0,0,1,.44-.61c.47-.48,1-.75,1.22-1.27a1.34,1.34,0,0,0,0-1.11.68.68,0,0,0-.44-.35.65.65,0,0,0-.61.26,1.27,1.27,0,0,0-.22.38.87.87,0,0,0-.58-.9.63.63,0,0,0-.52.16,1.34,1.34,0,0,0-.4,1C58.86,75.85,59.29,76.3,59.58,76.92Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M62.72,78a2.91,2.91,0,0,1,.18.69,1.11,1.11,0,0,1,0,.19c0,.06,0,.08,0,.09h0s.1-.15.11-.18a2.7,2.7,0,0,1,.48-.58c.49-.45,1-.68,1.29-1.19a1.31,1.31,0,0,0,0-1.11.64.64,0,0,0-.42-.37.62.62,0,0,0-.62.22,1,1,0,0,0-.24.36.87.87,0,0,0-.53-.93.58.58,0,0,0-.53.13,1.24,1.24,0,0,0-.45,1A5.21,5.21,0,0,0,62.72,78Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M66.62,78.52a2.42,2.42,0,0,1,.29.65c0,.06,0,.12,0,.18s0,.08,0,.08h0s.07-.16.08-.19a3.07,3.07,0,0,1,.38-.66c.41-.53.93-.87,1.08-1.41a1.33,1.33,0,0,0-.16-1.1.64.64,0,0,0-.48-.29.7.7,0,0,0-.58.33,1.61,1.61,0,0,0-.17.4c-.07-.45-.34-.8-.68-.82a.65.65,0,0,0-.5.23A1.31,1.31,0,0,0,65.7,77C65.8,77.55,66.27,78,66.62,78.52Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M70.3,78.39a2.27,2.27,0,0,1,.32.62.64.64,0,0,1,.06.18s0,.08,0,.08h0s.06-.17.07-.2a2.31,2.31,0,0,1,.35-.68c.38-.56.87-.93,1-1.48a1.33,1.33,0,0,0-.23-1.08.6.6,0,0,0-.48-.26.69.69,0,0,0-.57.36,1.3,1.3,0,0,0-.15.42c-.09-.45-.38-.78-.72-.78a.64.64,0,0,0-.49.26,1.29,1.29,0,0,0-.22,1.08C69.43,77.46,69.92,77.83,70.3,78.39Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M74.08,77.82a2.36,2.36,0,0,1,.51.45l.11.15s0,.06.06.06a0,0,0,0,0,0,0h0s0-.18,0-.21a2.93,2.93,0,0,1,.1-.78,5.54,5.54,0,0,0,.46-1.76,1.33,1.33,0,0,0-.57-.93.61.61,0,0,0-.54-.05.76.76,0,0,0-.41.56,1.29,1.29,0,0,0,0,.44.79.79,0,0,0-.92-.45.67.67,0,0,0-.37.43,1.3,1.3,0,0,0,.14,1.1C73,77.29,73.54,77.44,74.08,77.82Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M77.4,76.45a2.37,2.37,0,0,1,.5.46s.08.09.12.15,0,.06.06.06h0s0-.18,0-.22a2.51,2.51,0,0,1,.1-.77,5.57,5.57,0,0,0,.45-1.76,1.25,1.25,0,0,0-.57-.93.61.61,0,0,0-.54-.05.73.73,0,0,0-.41.55,1.36,1.36,0,0,0,0,.45.79.79,0,0,0-.93-.45.7.7,0,0,0-.37.43,1.37,1.37,0,0,0,.14,1.1C76.28,75.93,76.86,76.08,77.4,76.45Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M80.5,74.79a2.36,2.36,0,0,1,.57.36l.14.13s.06,0,.07,0h0s0-.18,0-.21a3.4,3.4,0,0,1,0-.78,5.4,5.4,0,0,0,.17-1.82,1.23,1.23,0,0,0-.71-.81.63.63,0,0,0-.54,0,.76.76,0,0,0-.31.63,1.72,1.72,0,0,0,.06.44.78.78,0,0,0-1-.28.76.76,0,0,0-.3.5,1.32,1.32,0,0,0,.32,1.06C79.31,74.49,79.91,74.53,80.5,74.79Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M83.43,72a2.14,2.14,0,0,1,.66.06l.18,0s.07,0,.08,0h0s-.1-.15-.12-.18a2.74,2.74,0,0,1-.33-.69,5.59,5.59,0,0,0-.58-1.72,1.08,1.08,0,0,0-1-.39.6.6,0,0,0-.47.29.77.77,0,0,0,0,.71,1.2,1.2,0,0,0,.23.37.76.76,0,0,0-1,.22.72.72,0,0,0-.08.58,1.23,1.23,0,0,0,.72.8C82.24,72.25,82.8,72,83.43,72Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M89.89,91.52S75.61,93,68.34,95.78l-2.52-2.45s18.64-4.51,23.74-4.24Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.61,94.19a2.09,2.09,0,0,1-.36.37l-.12.08,0,0h0s.13,0,.15,0a1.75,1.75,0,0,1,.56.12c.48.18.85.48,1.26.46a.91.91,0,0,0,.72-.4.53.53,0,0,0,.07-.42.54.54,0,0,0-.38-.35.88.88,0,0,0-.33,0,.63.63,0,0,0,.39-.7.48.48,0,0,0-.29-.32.89.89,0,0,0-.81.05C68.07,93.33,67.92,93.78,67.61,94.19Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.21,93.4a1.85,1.85,0,0,1-.36.38l-.12.08,0,0h0s.13,0,.15,0a2.15,2.15,0,0,1,.57.13c.47.17.84.48,1.25.46a.91.91,0,0,0,.72-.4.53.53,0,0,0,.07-.42.52.52,0,0,0-.38-.35.85.85,0,0,0-.32,0,.66.66,0,0,0,.39-.7.5.5,0,0,0-.3-.32.89.89,0,0,0-.81,0C70.67,92.55,70.52,93,70.21,93.4Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.85,92.63a1.94,1.94,0,0,1-.4.34.67.67,0,0,1-.12.06s-.06,0,0,0h0s.13,0,.16,0a1.91,1.91,0,0,1,.54.18c.45.22.79.56,1.21.58a.91.91,0,0,0,.75-.32.53.53,0,0,0,.11-.42.52.52,0,0,0-.34-.38.71.71,0,0,0-.32-.07.64.64,0,0,0,.45-.67.49.49,0,0,0-.26-.34.89.89,0,0,0-.81,0C73.39,91.82,73.2,92.26,72.85,92.63Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.52,92.11a2.24,2.24,0,0,1-.4.34l-.13.07,0,0h0s.13,0,.16,0a1.72,1.72,0,0,1,.54.18c.46.22.8.55,1.21.58A.89.89,0,0,0,77.6,93a.51.51,0,0,0,.12-.42.59.59,0,0,0-.35-.39.79.79,0,0,0-.32-.06.65.65,0,0,0,.46-.67.52.52,0,0,0-.26-.34.89.89,0,0,0-.81,0C76.06,91.3,75.86,91.74,75.52,92.11Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.19,91.57a1.67,1.67,0,0,1-.41.32.52.52,0,0,1-.13.06l-.05,0h0s.14,0,.16,0a1.87,1.87,0,0,1,.53.2c.45.24.77.59,1.19.63a.89.89,0,0,0,.76-.3.46.46,0,0,0,.13-.41.51.51,0,0,0-.33-.4,1,1,0,0,0-.32-.08A.64.64,0,0,0,80.2,91a.5.5,0,0,0-.24-.35.91.91,0,0,0-.82-.06C78.76,90.78,78.55,91.21,78.19,91.57Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.88,91.14a2.36,2.36,0,0,1-.42.33l-.12.06-.06,0h0s.13,0,.15,0a1.54,1.54,0,0,1,.54.2c.44.23.77.58,1.18.62a.92.92,0,0,0,.77-.29.53.53,0,0,0,.13-.41.58.58,0,0,0-.34-.41.78.78,0,0,0-.31-.07.65.65,0,0,0,.48-.65.47.47,0,0,0-.25-.35.93.93,0,0,0-.81-.07C81.44,90.36,81.24,90.78,80.88,91.14Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.6,90.7a1.76,1.76,0,0,1-.43.31l-.13,0-.05,0h0s.13,0,.16,0a1.7,1.7,0,0,1,.52.22c.43.26.74.62,1.16.68a.89.89,0,0,0,.77-.26.47.47,0,0,0,.15-.4.53.53,0,0,0-.31-.42,1,1,0,0,0-.31-.09.65.65,0,0,0,.51-.62.53.53,0,0,0-.23-.37.93.93,0,0,0-.81-.1C84.21,89.94,84,90.36,83.6,90.7Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.33,90.32a2,2,0,0,1-.41.33l-.13.06s-.05,0-.05,0h0s.14,0,.16,0a1.87,1.87,0,0,1,.53.2c.45.24.77.58,1.19.63a.93.93,0,0,0,.76-.3.52.52,0,0,0,.13-.41.51.51,0,0,0-.33-.4,1,1,0,0,0-.31-.08.67.67,0,0,0,.48-.65.55.55,0,0,0-.25-.35.89.89,0,0,0-.81-.06C86.9,89.54,86.69,90,86.33,90.32Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89,89.9a1.72,1.72,0,0,1-.42.32l-.12.07s-.06,0-.06,0h0s.13,0,.15,0a1.74,1.74,0,0,1,.54.19c.44.25.77.59,1.18.63a.92.92,0,0,0,.77-.29.52.52,0,0,0,.13-.41.55.55,0,0,0-.33-.4.84.84,0,0,0-.32-.08.64.64,0,0,0,.48-.65.5.5,0,0,0-.24-.35A.91.91,0,0,0,90,89C89.58,89.12,89.38,89.54,89,89.9Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M89.24,69.47s-.56,18.88.27,21.38S102,112.69,102,112.69l27.2,2.93s-25.87-39-32.95-44.21A14.63,14.63,0,0,0,89.24,69.47Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 92.47,
    cy: 89.48,
    r: 1.87
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.6 71.48 63.22 108.11 67.23 108.65 36.35 70.73 33.6 71.48"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M64.37,107.72A2.45,2.45,0,0,1,65,108l.15.09s.07,0,.07,0,0,0,0,0h0s0-.16-.06-.19a2.34,2.34,0,0,1-.13-.7,4.53,4.53,0,0,0-.07-1.67,1.14,1.14,0,0,0-.8-.63.6.6,0,0,0-.52.12.66.66,0,0,0-.22.61,1.21,1.21,0,0,0,.11.39.8.8,0,0,0-1-.11.64.64,0,0,0-.22.48,1.12,1.12,0,0,0,.45.92A4.51,4.51,0,0,0,64.37,107.72Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M62.23,105.11a2.34,2.34,0,0,1,.61.24l.15.09.07,0v0s0,0,0,0,0-.16-.06-.18a2.85,2.85,0,0,1-.12-.71,5,5,0,0,0-.07-1.67,1.16,1.16,0,0,0-.8-.63.62.62,0,0,0-.53.12.69.69,0,0,0-.22.61,1,1,0,0,0,.12.39.8.8,0,0,0-1-.11.62.62,0,0,0-.23.48,1.15,1.15,0,0,0,.45.92A4.85,4.85,0,0,0,62.23,105.11Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M60.08,102.48a2.62,2.62,0,0,1,.61.25l.15.09.07,0s0,0,0,0h0s0-.16-.06-.19a2.34,2.34,0,0,1-.13-.7,4.53,4.53,0,0,0-.07-1.67,1.14,1.14,0,0,0-.8-.63.63.63,0,0,0-.52.12.67.67,0,0,0-.23.61,1.58,1.58,0,0,0,.12.39.8.8,0,0,0-1-.11.61.61,0,0,0-.22.48,1.14,1.14,0,0,0,.44.92A4.63,4.63,0,0,0,60.08,102.48Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M57.94,99.87a2.15,2.15,0,0,1,.6.24l.15.09a.18.18,0,0,0,.08,0h0a0,0,0,0,0,0,0s-.05-.15-.06-.18a2.47,2.47,0,0,1-.13-.71,4.54,4.54,0,0,0-.07-1.67,1.14,1.14,0,0,0-.8-.63.63.63,0,0,0-.52.12.66.66,0,0,0-.22.61,1.15,1.15,0,0,0,.11.39.8.8,0,0,0-1-.11.65.65,0,0,0-.22.49,1.11,1.11,0,0,0,.45.91A4.72,4.72,0,0,0,57.94,99.87Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M55.79,97.25a2.21,2.21,0,0,1,.61.24l.15.1.07,0h0s-.05-.16-.06-.19a2.85,2.85,0,0,1-.12-.7A5.08,5.08,0,0,0,56.38,95a1.16,1.16,0,0,0-.8-.63.65.65,0,0,0-.53.12.69.69,0,0,0-.22.61,1,1,0,0,0,.12.39.8.8,0,0,0-1-.11.64.64,0,0,0-.23.49,1.14,1.14,0,0,0,.45.91A4.85,4.85,0,0,0,55.79,97.25Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M53.64,94.63a2.21,2.21,0,0,1,.61.24l.15.1a.11.11,0,0,0,.07,0h0s-.05-.16-.06-.19a2.4,2.4,0,0,1-.13-.7,4.53,4.53,0,0,0-.07-1.67,1.13,1.13,0,0,0-.8-.64.67.67,0,0,0-.52.12.68.68,0,0,0-.23.61,1.46,1.46,0,0,0,.12.39.81.81,0,0,0-1-.11.67.67,0,0,0-.23.49,1.17,1.17,0,0,0,.45.91C52.44,94.52,53,94.47,53.64,94.63Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M51.49,92a2.42,2.42,0,0,1,.61.24l.15.1s.07,0,.07,0h0s-.05-.16-.06-.19a2.1,2.1,0,0,1-.12-.7,4.74,4.74,0,0,0-.08-1.67,1.13,1.13,0,0,0-.8-.64.62.62,0,0,0-.74.73,1.15,1.15,0,0,0,.11.39.8.8,0,0,0-1-.11.64.64,0,0,0-.23.49,1.1,1.1,0,0,0,.45.91C50.29,91.9,50.88,91.85,51.49,92Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M49.35,89.39a2.57,2.57,0,0,1,.61.24l.15.1s.06,0,.07,0h0s0-.16-.06-.19a2.78,2.78,0,0,1-.12-.7,5,5,0,0,0-.07-1.67,1.15,1.15,0,0,0-.8-.64.62.62,0,0,0-.75.73,1,1,0,0,0,.12.39.82.82,0,0,0-1-.11.67.67,0,0,0-.23.49,1.16,1.16,0,0,0,.45.92A4.86,4.86,0,0,0,49.35,89.39Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M47.2,86.77a2.25,2.25,0,0,1,.61.25.6.6,0,0,1,.15.09s.06,0,.07,0,0,0,0,0h0s0-.16-.06-.19a2.34,2.34,0,0,1-.13-.7,4.53,4.53,0,0,0-.07-1.67,1.09,1.09,0,0,0-.8-.63.63.63,0,0,0-.52.11.68.68,0,0,0-.23.61,1.36,1.36,0,0,0,.12.39.81.81,0,0,0-1-.11.63.63,0,0,0-.22.49,1.14,1.14,0,0,0,.44.92A4.86,4.86,0,0,0,47.2,86.77Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M45.06,84.15a2.19,2.19,0,0,1,.6.25l.15.09s.07,0,.08,0h0s0-.16-.06-.19a2.06,2.06,0,0,1-.12-.7A4.74,4.74,0,0,0,45.64,82a1.14,1.14,0,0,0-.8-.63.6.6,0,0,0-.52.12.64.64,0,0,0-.22.6,1.09,1.09,0,0,0,.11.39.78.78,0,0,0-1-.1.62.62,0,0,0-.23.48,1.12,1.12,0,0,0,.45.92A4.57,4.57,0,0,0,45.06,84.15Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M42.91,81.53a2.62,2.62,0,0,1,.61.25l.15.09s.06,0,.07,0h0s0,0,0,0,0-.16,0-.19a2.34,2.34,0,0,1-.13-.7,5,5,0,0,0-.07-1.67,1.16,1.16,0,0,0-.8-.63.62.62,0,0,0-.53.12.69.69,0,0,0-.22.61,1,1,0,0,0,.12.39.79.79,0,0,0-1-.11.65.65,0,0,0-.23.48,1.15,1.15,0,0,0,.45.92A4.63,4.63,0,0,0,42.91,81.53Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M40.76,78.92a2.21,2.21,0,0,1,.61.24l.15.09.07,0h0a0,0,0,0,0,0,0s0-.16-.06-.18a2.47,2.47,0,0,1-.13-.71,4.53,4.53,0,0,0-.07-1.67,1.14,1.14,0,0,0-.8-.63.63.63,0,0,0-.52.12.66.66,0,0,0-.22.61,1.15,1.15,0,0,0,.11.39.8.8,0,0,0-1-.11.61.61,0,0,0-.22.48,1.14,1.14,0,0,0,.44.92A4.85,4.85,0,0,0,40.76,78.92Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M38.62,76.3a2.15,2.15,0,0,1,.6.24l.15.09a.18.18,0,0,0,.08,0h0s-.05-.16-.06-.18a2.15,2.15,0,0,1-.12-.7,4.79,4.79,0,0,0-.08-1.68,1.14,1.14,0,0,0-.79-.63.65.65,0,0,0-.53.12.66.66,0,0,0-.22.61,1,1,0,0,0,.12.39.8.8,0,0,0-1-.11.62.62,0,0,0-.23.49,1.11,1.11,0,0,0,.45.91A4.72,4.72,0,0,0,38.62,76.3Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M36.47,73.68a2.21,2.21,0,0,1,.61.24l.15.1.07,0h0s0-.16-.05-.19a2.47,2.47,0,0,1-.13-.7,4.82,4.82,0,0,0-.07-1.68,1.16,1.16,0,0,0-.8-.63.63.63,0,0,0-.52.12.67.67,0,0,0-.23.61,1,1,0,0,0,.12.39.8.8,0,0,0-1-.11.67.67,0,0,0-.23.49,1.14,1.14,0,0,0,.45.91A4.85,4.85,0,0,0,36.47,73.68Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "43.68 69.19 79.83 109.92 82.51 109.86 45.03 68.48 43.14 69.07"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.26,71.41s-1.08,16-.41,18.11,14.66,23.84,14.66,23.84h1.17L97,89a161,161,0,0,1,.34-16.83Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M89,27.87a55.56,55.56,0,0,1,2.51-11.58,2.4,2.4,0,0,0-1.93,1.22,4.07,4.07,0,0,0-.52,1.34,2.86,2.86,0,0,0-2.57-2.47,2.24,2.24,0,0,0-1.68.87,4,4,0,0,0-.73,3.54c.48,1.77,2.24,2.94,3.61,4.7a8.69,8.69,0,0,1,1.17,2C89,27.61,89,27.75,89,27.87Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M60.41,23.4a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.05,5.05,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75,1.61,1.61,0,0,0-1.44-1.39,1.3,1.3,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C58.64,21.75,59.64,22.4,60.41,23.4Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 56.79 120.67 58.77 120.67 55.5 116.72 53.52 116.72 56.79"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 60.07 120.67 62.05 120.67 58.77 116.72 56.79 116.72 60.07"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 63.34 120.67 65.33 120.67 62.05 116.72 60.07 116.72 63.34"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 66.62 120.67 68.6 120.67 65.33 116.72 63.34 116.72 66.62"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 69.9 120.67 71.88 120.67 68.6 116.72 66.62 116.72 69.9"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 73.17 120.67 75.15 120.67 71.88 116.72 69.9 116.72 73.17"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 76.45 120.67 78.43 120.67 75.15 116.72 73.17 116.72 76.45"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 79.73 120.67 81.71 120.67 78.43 116.72 76.45 116.72 79.73"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 83 120.67 84.98 120.67 81.71 116.72 79.73 116.72 83"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 86.28 120.67 88.26 120.67 84.98 116.72 83 116.72 86.28"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 89.56 120.67 91.54 120.67 88.26 116.72 86.28 116.72 89.56"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 92.83 120.67 94.81 120.67 91.54 116.72 89.56 116.72 92.83"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 96.11 120.67 98.09 120.67 94.81 116.72 92.83 116.72 96.11"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 99.38 120.67 101.36 120.67 98.09 116.72 96.11 116.72 99.38"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 102.66 120.67 104.64 120.67 101.36 116.72 99.38 116.72 102.66"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 105.94 120.67 107.92 120.67 104.64 116.72 102.66 116.72 105.94"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "116.72 109.21 120.67 111.19 120.67 107.92 116.72 105.94 116.72 109.21"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.72 112.49 120.67 114.47 120.67 111.19 116.72 109.21 116.72 112.49"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 115.97,
    y: 61.72,
    width: 5.64,
    height: 11.28
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    transform: "translate(108.52 43.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACXUlEQVQ4T6WUSXbcMAxEP8Ch2xkOlJf49LbTuZCfJRFDFpTkOPYqwUYSAZaKBRQlM/koHh5vWYqSmYgI7oGokDHr7398k4/2yd+AD4+3rLVQaqGUirtjY9B6x93JTDITd4d8D/wG8OHplq01eu/UWik6GZo77k4phTEGY2y4ByQgcP/9FfQEfHi6Ze+du+uV2iqtVkSUZVkQFYoWlnUlI6it8fz8jIhgZoTHyVQP5ForvXdE55KZo0W53l1prVFb5e7uyuV6AZLL5QK7vjClAqjHR22VMTa+fP5EKQWAoorMUyGqZCQhQatt/2mZp25gwzkBAXrvfP3yeQKVQmQioogkpRRy16vVyrYNAFprqCpmhpacxIBdI0W1kEygVpSI2MEmmogQEfQuvCwvqAipb6dHATKSJDE3ainM9r3qAxAZZAa551o9DieoKrprXwG0KLInIgJRRfZ5A+bsRRCRZAaRSWSC7LmMs7YChAceQUaQomQEvnfwGOTYn5mzPiIwMzKZaxFvGZJJRII4kKgqCagIsTtDAPPZTTPf2U8pjjgZRibLus6B7p3M6V3fvUsmHknGbjuO5ZkXEZJ8HRsyKWWyggNkFnHaczYEEeQsE8aw09cK82Ubg20bbNvGNgbujrthZoxhvCwLy7Ji7qzLwrKurOvKtm38GSfD8GCMQa0VM2NdN1SVUgpmg8zpnHXdcHciZmfDp37vvHz/45uYGRHOto1d6MTNTgWOhkTEBPXXZhzx7j58/PkrMxJR4dI7yRwVM0NkusWGTYPz9ur6EPCIx6fbu9Q/3dj/G78BbV7SvplF4sMAAAAASUVORK5CYII="
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "113.62 60.26 110.29 62.26 111.79 58.59 113.62 60.26"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "109.8 54.18 106.05 53.15 109.74 51.71 109.8 54.18"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "111.56 47.22 109.73 43.79 113.32 45.47 111.56 47.22"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "117.83 43.7 119.05 40.02 120.3 43.77 117.83 43.7"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "124.69 45.82 128.21 44.17 126.34 47.66 124.69 45.82"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "127.89 52.25 131.51 53.67 127.69 54.72 127.89 52.25"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "125.42 59 126.89 62.6 123.5 60.56 125.42 59"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M119.93,52.69a1.17,1.17,0,1,1-1.17-1.17A1.16,1.16,0,0,1,119.93,52.69Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.44,153.69l28.37-5.36s5.62-.53,5.62-7.23V115.39l-99.6-11.52s25.12,37.5,33,44.2c.88.75,4.92,1.64,9.88,2.48C81.31,152.2,94.44,153.69,94.44,153.69Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.25,191.71l-19.74-1.57L69,188l-2.49-13.76,2.71-.71-.38-3.13,2.3-1.47L71,167.1S73.53,166,72,164.53s-2.8-4.39,4.3-4.8c4.32-.24,6.52-2.25,2.9-8.43,0,.57,3-4,7.66-4.3,7.18-.42,17.15,3.21,17.15,3.21S88.59,186,88.25,191.71Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.51,187.63a2.29,2.29,0,0,1,1.24-2.92,12.72,12.72,0,0,1,2.75.84c1.62.66,5.17.23,5.65-.35s-1,3.29-6.62,1.61C69.05,185.78,69.51,187.63,69.51,187.63Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.47,184.22a6,6,0,0,1,3.26.08c1.62.55,3.85.43,4.93-.57a9.06,9.06,0,0,1-4.3-.28s.55-2-.66-2.2-1.3,2-1.3,2A3.17,3.17,0,0,0,70.47,184.22Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.93,192.25s.14-23.38-2.1-28.93c0,0-6.23-14.21,26.3-8.63,0,0,2.53,6.1-3.52,7.08,0,0,4.31,31.24-.58,30.44Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M110.13,154.69s4.43,10.17-22.88,7.45C87.25,162.14,115.64,166.67,110.13,154.69Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.65,191.39s-.22-20.13-.92-29c0,0,4.35,18.89,3,28.86Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.8,191.85a91.25,91.25,0,0,0-.51-27.33s4.13,14.54,2.16,27.22Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.44,193a91.4,91.4,0,0,0-.52-27.32s4.14,14.54,2.16,27.21Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M94.05,162.32s7.72-4.81.67-8.44C94.72,153.88,100,157.27,94.05,162.32Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.62,162.34s7.72-4.81.66-8.44C102.28,153.9,107.53,157.29,101.62,162.34Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M107.86,190.67A185,185,0,0,1,69.19,190l-2.83,14.22s8.67,3.74,13.33.36c0,0,5.34-2.67,8.5-1.42s5,3.91,9.67,2.31,9.5-8.71,13.5-8Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.19,189.46s-15.66,2.5-39.33-.17l-.17,2.5s23.34,3.17,40.17.34Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M80.45,152.63,68.8,150S70.13,138.36,87,138s27.93,12.45,27.93,12.45l-11.21,2s-8-6.66-16.25-5.25S80.45,152.63,80.45,152.63Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M110.25,151.52l-38.57-43,56.75,7v29.6a11.62,11.62,0,0,1-5.62,3.35C119.56,149.11,110.25,151.52,110.25,151.52Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M125.63,137.46a4.25,4.25,0,0,1-.66-1.12,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0,0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.69,1.72-1.93,2.73a2.26,2.26,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2,2,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C127.39,139.12,126.4,138.46,125.63,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M119,137.46a4.53,4.53,0,0,1-.66-1.12,3.4,3.4,0,0,1-.12-.34c0-.09-.06-.14-.08-.14v0l0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.74,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C120.77,139.12,119.78,138.46,119,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M112.38,137.46a4.25,4.25,0,0,1-.66-1.12,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0,0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.69,1.72-1.93,2.73a2.26,2.26,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2,2,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C114.14,139.12,113.15,138.46,112.38,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M105.75,137.46a4.53,4.53,0,0,1-.66-1.12A3.4,3.4,0,0,1,105,136c0-.09-.06-.14-.08-.14v0l0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.74,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C107.52,139.12,106.53,138.46,105.75,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M99.13,137.46a4.25,4.25,0,0,1-.66-1.12,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0,0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.69,1.72-1.93,2.73a2.26,2.26,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2,2,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C100.89,139.12,99.9,138.46,99.13,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M92.5,137.46a4.53,4.53,0,0,1-.66-1.12,3.4,3.4,0,0,1-.12-.34c0-.09-.06-.14-.08-.14v0l0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.74,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C94.27,139.12,93.28,138.46,92.5,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M85.88,137.46a4.25,4.25,0,0,1-.66-1.12,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0,0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.69,1.72-1.93,2.73a2.26,2.26,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2,2,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C87.64,139.12,86.65,138.46,85.88,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M79.25,137.46a4.53,4.53,0,0,1-.66-1.12,3.4,3.4,0,0,1-.12-.34c0-.09-.06-.14-.08-.14v0l0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.74,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C81,139.12,80,138.46,79.25,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M72.63,137.46a4.25,4.25,0,0,1-.66-1.12,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0,0,0c-.07,0-.12.32-.14.37a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.69,1.72-1.93,2.73a2.26,2.26,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2,2,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.28,1.28,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C74.39,139.12,73.4,138.46,72.63,137.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M73.85,135.72a4.82,4.82,0,0,1,.67,1.13c0,.1.08.22.12.33s0,.14.07.14h0c.07,0,.12-.31.14-.37a4.6,4.6,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.74a2.24,2.24,0,0,0-.49-2,1.3,1.3,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.23,2.23,0,0,0-.41,2C72.09,134.07,73.08,134.72,73.85,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M80.48,135.72a4.48,4.48,0,0,1,.66,1.13,1.85,1.85,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.11-.31.13-.37a5.21,5.21,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.74a2.3,2.3,0,0,0-.49-2,1.33,1.33,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.29,2.29,0,0,0-.41,2C78.71,134.07,79.71,134.72,80.48,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M87.1,135.72a4.82,4.82,0,0,1,.67,1.13c0,.1.08.22.12.33s0,.14.07.14h0c.07,0,.12-.31.14-.37a4.6,4.6,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.74a2.24,2.24,0,0,0-.49-2,1.3,1.3,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.23,2.23,0,0,0-.41,2C85.34,134.07,86.33,134.72,87.1,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M93.73,135.72a4.48,4.48,0,0,1,.66,1.13,1.85,1.85,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.11-.31.13-.37a5.21,5.21,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.74a2.3,2.3,0,0,0-.49-2,1.33,1.33,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.29,2.29,0,0,0-.41,2C92,134.07,93,134.72,93.73,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M100.35,135.72a4.82,4.82,0,0,1,.67,1.13c0,.1.08.22.12.33s0,.14.07.14h0c.07,0,.12-.31.14-.37a4.6,4.6,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.74a2.24,2.24,0,0,0-.49-2,1.3,1.3,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.23,2.23,0,0,0-.41,2C98.59,134.07,99.58,134.72,100.35,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M107,135.72a4.48,4.48,0,0,1,.66,1.13,1.85,1.85,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.11-.31.13-.37a5.21,5.21,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.74a2.3,2.3,0,0,0-.49-2,1.33,1.33,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.29,2.29,0,0,0-.41,2C105.21,134.07,106.21,134.72,107,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M113.6,135.72a4.82,4.82,0,0,1,.67,1.13c0,.1.08.22.12.33s0,.14.07.14h0c.07,0,.12-.31.14-.37a4.6,4.6,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.74a2.24,2.24,0,0,0-.49-2,1.3,1.3,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.23,2.23,0,0,0-.41,2C111.84,134.07,112.83,134.72,113.6,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M120.23,135.72a4.48,4.48,0,0,1,.66,1.13,1.85,1.85,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.11-.31.13-.37a5.21,5.21,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.74a2.3,2.3,0,0,0-.49-2,1.33,1.33,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.29,2.29,0,0,0-.41,2C118.46,134.07,119.46,134.72,120.23,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M126.85,135.72a4.82,4.82,0,0,1,.67,1.13c0,.1.08.22.12.33s0,.14.07.14h0c.07,0,.12-.31.14-.37a4.6,4.6,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.74a2.24,2.24,0,0,0-.49-2,1.3,1.3,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.11,2.11,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.23,2.23,0,0,0-.41,2C125.09,134.07,126.08,134.72,126.85,135.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M126.26,151a4.48,4.48,0,0,1-.66-1.13,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0s0,0,0,0-.12.31-.14.36a4.92,4.92,0,0,1-.65,1.27c-.74,1-1.7,1.72-1.94,2.73a2.29,2.29,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.24,2.24,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.4,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C128,152.65,127,152,126.26,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M119.63,151a5.16,5.16,0,0,1-.66-1.13l-.12-.34c0-.09,0-.14-.07-.14a0,0,0,0,0,0,0s0,0,0,0-.12.31-.14.36a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C121.4,152.65,120.41,152,119.63,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M113,151a4.48,4.48,0,0,1-.66-1.13,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0s0,0,0,0-.12.31-.14.36a4.92,4.92,0,0,1-.65,1.27c-.74,1-1.7,1.72-1.94,2.73a2.29,2.29,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.24,2.24,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.4,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C114.77,152.65,113.78,152,113,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M106.38,151a5.16,5.16,0,0,1-.66-1.13l-.12-.34c0-.09,0-.14-.07-.14a0,0,0,0,0,0,0s0,0,0,0-.12.31-.14.36a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C108.15,152.65,107.16,152,106.38,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M99.76,151a4.48,4.48,0,0,1-.66-1.13,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0s0,0,0,0-.12.31-.14.36a4.92,4.92,0,0,1-.65,1.27c-.74,1-1.7,1.72-1.94,2.73a2.29,2.29,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.24,2.24,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.4,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C101.52,152.65,100.53,152,99.76,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M93.13,151a5.16,5.16,0,0,1-.66-1.13l-.12-.34c0-.09,0-.14-.07-.14a0,0,0,0,0,0,0s0,0,0,0-.12.31-.14.36a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C94.9,152.65,93.91,152,93.13,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M86.51,151a4.48,4.48,0,0,1-.66-1.13,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0s0,0,0,0-.12.31-.14.36a4.92,4.92,0,0,1-.65,1.27c-.74,1-1.7,1.72-1.94,2.73a2.29,2.29,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.24,2.24,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.4,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C88.27,152.65,87.28,152,86.51,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M79.88,151a5.16,5.16,0,0,1-.66-1.13l-.12-.34c0-.09,0-.14-.07-.14a0,0,0,0,0,0,0s0,0,0,0-.12.31-.14.36a4.65,4.65,0,0,1-.66,1.27c-.73,1-1.7,1.72-1.93,2.73a2.28,2.28,0,0,0,.48,2,1.29,1.29,0,0,0,1,.45,1.36,1.36,0,0,0,1.1-.69,2.45,2.45,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.4,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C81.65,152.65,80.66,152,79.88,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M73.26,151a4.48,4.48,0,0,1-.66-1.13,3.42,3.42,0,0,1-.13-.34c0-.09,0-.14-.07-.14l0,0s0,0,0,0-.12.31-.14.36a4.92,4.92,0,0,1-.65,1.27c-.74,1-1.7,1.72-1.94,2.73a2.29,2.29,0,0,0,.49,2,1.26,1.26,0,0,0,1,.45,1.34,1.34,0,0,0,1.1-.69,2.24,2.24,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.4,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C75,152.65,74,152,73.26,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M74.48,149.25a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.31,2.31,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C72.72,147.6,73.71,148.25,74.48,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M81.11,149.25a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.59,1.59,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.3,2.3,0,0,0-.41,2C79.35,147.6,80.34,148.25,81.11,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M87.73,149.25a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.31,2.31,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C86,147.6,87,148.25,87.73,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M94.36,149.25a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.59,1.59,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.3,2.3,0,0,0-.41,2C92.6,147.6,93.59,148.25,94.36,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M101,149.25a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.31,2.31,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C99.22,147.6,100.21,148.25,101,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M107.61,149.25a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.59,1.59,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.3,2.3,0,0,0-.41,2C105.85,147.6,106.84,148.25,107.61,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M114.23,149.25a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.31,2.31,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C112.47,147.6,113.46,148.25,114.23,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M120.86,149.25a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0c.06,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.36,1.36,0,0,0-1.1.69,2.32,2.32,0,0,0-.3.76,1.59,1.59,0,0,0-1.44-1.39,1.28,1.28,0,0,0-1,.49,2.3,2.3,0,0,0-.41,2C119.1,147.6,120.09,148.25,120.86,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M127.48,149.25a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.27,1.27,0,0,0-1-.46,1.37,1.37,0,0,0-1.1.69,2.31,2.31,0,0,0-.29.76,1.6,1.6,0,0,0-1.45-1.39,1.24,1.24,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C125.72,147.6,126.71,148.25,127.48,149.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M125.63,110.8a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.35,1.35,0,0,0,1.1-.7,2,2,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C127.39,112.45,126.4,111.79,125.63,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M119,110.8a4.8,4.8,0,0,1-.66-1.13c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.38,1.38,0,0,0,1.1-.7,2.39,2.39,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C120.77,112.45,119.78,111.79,119,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M112.38,110.8a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.35,1.35,0,0,0,1.1-.7,2,2,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C114.14,112.45,113.15,111.79,112.38,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M105.75,110.8a4.8,4.8,0,0,1-.66-1.13c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.38,1.38,0,0,0,1.1-.7,2.39,2.39,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C107.52,112.45,106.53,111.79,105.75,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M99.13,110.8a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.35,1.35,0,0,0,1.1-.7,2,2,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C100.89,112.45,99.9,111.79,99.13,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M92.5,110.8a4.8,4.8,0,0,1-.66-1.13c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.38,1.38,0,0,0,1.1-.7,2.39,2.39,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C94.27,112.45,93.28,111.79,92.5,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M85.88,110.8a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.35,1.35,0,0,0,1.1-.7,2,2,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C87.64,112.45,86.65,111.79,85.88,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M79.25,110.8a4.8,4.8,0,0,1-.66-1.13c0-.11-.09-.22-.12-.33s-.06-.14-.08-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.74,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.38,1.38,0,0,0,1.1-.7,2.39,2.39,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.26,1.26,0,0,0,.95-.49,2.31,2.31,0,0,0,.41-2C81,112.45,80,111.79,79.25,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M72.63,110.8a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.69,1.72-1.93,2.73a2.25,2.25,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.35,1.35,0,0,0,1.1-.7,2,2,0,0,0,.29-.75,1.61,1.61,0,0,0,1.45,1.39,1.24,1.24,0,0,0,1-.49,2.28,2.28,0,0,0,.42-2C74.39,112.45,73.4,111.79,72.63,110.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M73.85,109.05a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75,1.61,1.61,0,0,0-1.45-1.39,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C72.09,107.4,73.08,108.06,73.85,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M80.48,109.05a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.41,5.41,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75,1.61,1.61,0,0,0-1.44-1.39,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C78.71,107.4,79.71,108.06,80.48,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M87.1,109.05a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37A4.74,4.74,0,0,1,88.8,109c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75,1.61,1.61,0,0,0-1.45-1.39,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C85.34,107.4,86.33,108.06,87.1,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M93.73,109.05a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.41,5.41,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75,1.61,1.61,0,0,0-1.44-1.39,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C92,107.4,93,108.06,93.73,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M100.35,109.05a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75,1.61,1.61,0,0,0-1.45-1.39,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C98.59,107.4,99.58,108.06,100.35,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M107,109.05a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.41,5.41,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75,1.61,1.61,0,0,0-1.44-1.39,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C105.21,107.4,106.21,108.06,107,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M113.6,109.05a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75,1.61,1.61,0,0,0-1.45-1.39,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C111.84,107.4,112.83,108.06,113.6,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M120.23,109.05a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.14h0s0,0,0,0,.11-.31.13-.37a5.41,5.41,0,0,1,.66-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.29,1.29,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.19,2.19,0,0,0-.3.75,1.61,1.61,0,0,0-1.44-1.39,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C118.46,107.4,119.46,108.06,120.23,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M126.85,109.05a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.14s0,0,0,0h0c.07,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2,2,0,0,0-.29.75,1.61,1.61,0,0,0-1.45-1.39,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C125.09,107.4,126.08,108.06,126.85,109.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M126.26,124.33a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a5,5,0,0,1-.65,1.26c-.74,1-1.7,1.72-1.94,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.32,2.32,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.39,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C128,126,127,125.33,126.26,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M119.63,124.33a5.16,5.16,0,0,1-.66-1.13l-.12-.33c0-.1,0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.39,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C121.4,126,120.41,125.33,119.63,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M113,124.33a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a5,5,0,0,1-.65,1.26c-.74,1-1.7,1.72-1.94,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.32,2.32,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.39,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C114.77,126,113.78,125.33,113,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M106.38,124.33a5.16,5.16,0,0,1-.66-1.13l-.12-.33c0-.1,0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.39,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C108.15,126,107.16,125.33,106.38,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M99.76,124.33a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a5,5,0,0,1-.65,1.26c-.74,1-1.7,1.72-1.94,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.32,2.32,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.39,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C101.52,126,100.53,125.33,99.76,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M93.13,124.33a5.16,5.16,0,0,1-.66-1.13l-.12-.33c0-.1,0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.39,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C94.9,126,93.91,125.33,93.13,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M86.51,124.33a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a5,5,0,0,1-.65,1.26c-.74,1-1.7,1.72-1.94,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.32,2.32,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.39,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C88.27,126,87.28,125.33,86.51,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M79.88,124.33a5.16,5.16,0,0,1-.66-1.13l-.12-.33c0-.1,0-.14-.07-.14h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.39,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C81.65,126,80.66,125.33,79.88,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M73.26,124.33a4.48,4.48,0,0,1-.66-1.13c0-.11-.09-.22-.13-.33s0-.14-.07-.14h0c-.06,0-.12.31-.14.37a5,5,0,0,1-.65,1.26c-.74,1-1.7,1.72-1.94,2.73a2.28,2.28,0,0,0,.49,2,1.3,1.3,0,0,0,1,.46,1.36,1.36,0,0,0,1.1-.69,2.32,2.32,0,0,0,.3-.76,1.59,1.59,0,0,0,1.44,1.39,1.28,1.28,0,0,0,.95-.49,2.28,2.28,0,0,0,.42-2C75,126,74,125.33,73.26,124.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M74.48,122.58a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.15a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C72.72,120.93,73.71,121.59,74.48,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M81.11,122.58a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.15s0,0,0,0,0,0,0,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C79.35,120.93,80.34,121.59,81.11,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M87.73,122.58a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.15a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C86,120.93,87,121.59,87.73,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M94.36,122.58a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.15s0,0,0,0,0,0,0,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C92.6,120.93,93.59,121.59,94.36,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M101,122.58a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.15a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C99.22,120.93,100.21,121.59,101,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M107.61,122.58a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.15s0,0,0,0,0,0,0,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C105.85,120.93,106.84,121.59,107.61,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M114.23,122.58a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.15a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C112.47,120.93,113.46,121.59,114.23,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M120.86,122.58a4.48,4.48,0,0,1,.66,1.13,2.19,2.19,0,0,1,.12.33c0,.1.06.14.08.15s0,0,0,0,0,0,0,0,.12-.31.14-.37a5,5,0,0,1,.65-1.26c.74-1,1.7-1.72,1.94-2.73a2.31,2.31,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.31,1.31,0,0,0-1.1.69,2.16,2.16,0,0,0-.3.76,1.6,1.6,0,0,0-1.44-1.4,1.31,1.31,0,0,0-1,.49,2.31,2.31,0,0,0-.41,2C119.1,120.93,120.09,121.59,120.86,122.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M127.48,122.58a4.82,4.82,0,0,1,.67,1.13l.12.33c0,.1,0,.14.07.15a0,0,0,0,0,0,0s0,0,0,0,.12-.31.14-.37a4.74,4.74,0,0,1,.66-1.26c.73-1,1.7-1.72,1.93-2.73a2.25,2.25,0,0,0-.49-2,1.26,1.26,0,0,0-1-.45,1.33,1.33,0,0,0-1.1.69,2.15,2.15,0,0,0-.29.76,1.61,1.61,0,0,0-1.45-1.4,1.28,1.28,0,0,0-1,.49,2.24,2.24,0,0,0-.41,2C125.72,120.93,126.71,121.59,127.48,122.58Z"
  }))), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "109.09 151.42 70.52 108.42 77.39 109.22 113.74 150.41 109.09 151.42"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "113.74 150.41 122.83 148.2 92.68 111.23 77.39 109.22 113.74 150.41"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "109.09 151.42 110.42 146.59 102.44 143.78 101.25 136.41 93.72 134.27 93.13 127.17 85.44 125.16 83.97 117.13 77.61 116.32 109.09 151.42"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M111.36,197.43c-.54-.07-2.38-2.51-9,3.48s-9.29.49-15.16.74-11,6-20.85,2.53c0,0,8.37,4.32,20.73-.45,0,0,1.46-.13,3.3,2s8.32.61,14.19-4.28S111.36,197.43,111.36,197.43Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M86.23,110.85a4.93,4.93,0,0,1-1.3-.49l-.32-.19c-.09-.06-.14-.08-.15-.07s0,0,0,0h0c-.06.05.1.33.13.4a5.25,5.25,0,0,1,.29,1.48c.08,1.33-.26,2.55.22,3.54a2.42,2.42,0,0,0,1.72,1.31,1.36,1.36,0,0,0,1.1-.27,1.43,1.43,0,0,0,.45-1.31,2.37,2.37,0,0,0-.26-.82,1.7,1.7,0,0,0,2.12.19,1.35,1.35,0,0,0,.46-1,2.41,2.41,0,0,0-1-1.92C88.78,111.05,87.53,111.16,86.23,110.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M90.88,116.32a4.87,4.87,0,0,1-1.29-.49,2.14,2.14,0,0,1-.32-.2c-.09-.06-.14-.07-.16-.06a0,0,0,0,0,0,0h0s.11.34.13.4a5.06,5.06,0,0,1,.3,1.48c.07,1.34-.26,2.55.22,3.54a2.36,2.36,0,0,0,1.71,1.31,1.35,1.35,0,0,0,1.11-.27,1.43,1.43,0,0,0,.45-1.3,2.4,2.4,0,0,0-.27-.82,1.71,1.71,0,0,0,2.13.19,1.35,1.35,0,0,0,.46-1,2.42,2.42,0,0,0-1-1.92C93.44,116.51,92.18,116.63,90.88,116.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M95.54,121.79a5.75,5.75,0,0,1-1.3-.49l-.32-.2c-.09-.06-.14-.08-.16-.07v0h0s.11.34.14.4a5.39,5.39,0,0,1,.29,1.48c.08,1.33-.26,2.55.22,3.54a2.4,2.4,0,0,0,1.72,1.31,1.37,1.37,0,0,0,1.1-.27,1.44,1.44,0,0,0,.45-1.3,2.37,2.37,0,0,0-.26-.82,1.71,1.71,0,0,0,2.12.19,1.37,1.37,0,0,0,.46-1,2.41,2.41,0,0,0-1-1.92C98.09,122,96.84,122.1,95.54,121.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M100.19,127.25a5.07,5.07,0,0,1-1.3-.49l-.32-.19c-.08-.06-.13-.08-.15-.07v0s0,0,0,0,.11.33.13.39a4.75,4.75,0,0,1,.29,1.49c.08,1.33-.26,2.54.22,3.54a2.42,2.42,0,0,0,1.72,1.31,1.39,1.39,0,0,0,1.11-.27,1.45,1.45,0,0,0,.44-1.31,2.37,2.37,0,0,0-.26-.82,1.7,1.7,0,0,0,2.12.19,1.36,1.36,0,0,0,.47-1,2.44,2.44,0,0,0-1-1.92C102.75,127.45,101.49,127.56,100.19,127.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M104.85,132.72a4.81,4.81,0,0,1-1.3-.49,2.14,2.14,0,0,1-.32-.2c-.09-.06-.14-.08-.16-.06a0,0,0,0,0,0,0h0c-.05,0,.11.34.13.4a5.06,5.06,0,0,1,.3,1.48c.07,1.34-.26,2.55.22,3.54a2.4,2.4,0,0,0,1.72,1.31,1.33,1.33,0,0,0,1.1-.27,1.43,1.43,0,0,0,.45-1.3,2.37,2.37,0,0,0-.26-.82,1.7,1.7,0,0,0,2.12.19,1.35,1.35,0,0,0,.46-1,2.39,2.39,0,0,0-1-1.92C107.4,132.91,106.15,133,104.85,132.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M109.5,138.19a5,5,0,0,1-1.3-.5,2.69,2.69,0,0,1-.32-.19q-.13-.09-.15-.06s0,0,0,0,0,0,0,0,.1.34.13.4a5.25,5.25,0,0,1,.29,1.48c.08,1.33-.26,2.55.22,3.54a2.42,2.42,0,0,0,1.72,1.31,1.36,1.36,0,0,0,1.1-.27,1.42,1.42,0,0,0,.45-1.3,2.37,2.37,0,0,0-.26-.82,1.71,1.71,0,0,0,2.12.19,1.37,1.37,0,0,0,.46-1,2.43,2.43,0,0,0-1-1.93C112.05,138.38,110.8,138.5,109.5,138.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M114.15,143.65a4.87,4.87,0,0,1-1.29-.49l-.33-.19c-.08-.06-.13-.08-.15-.07s0,0,0,0,0,0,0,0,.11.33.13.39a5.06,5.06,0,0,1,.3,1.49c.07,1.33-.26,2.54.21,3.54a2.44,2.44,0,0,0,1.72,1.31,1.36,1.36,0,0,0,1.11-.28,1.43,1.43,0,0,0,.45-1.3,2.4,2.4,0,0,0-.27-.82,1.71,1.71,0,0,0,2.13.19,1.35,1.35,0,0,0,.46-1,2.42,2.42,0,0,0-1-1.92C116.71,143.85,115.45,144,114.15,143.65Z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M108,148.72a3,3,0,0,1,.14-.7,1.34,1.34,0,0,0,.07-.18c0-.05,0-.07,0-.08h0v0s-.15.08-.18.1a2.42,2.42,0,0,1-.67.27c-.63.14-1.23.06-1.66.38a1.28,1.28,0,0,0-.5,1,.72.72,0,0,0,.21.54.62.62,0,0,0,.64.13.93.93,0,0,0,.37-.19.93.93,0,0,0,.06,1.09.59.59,0,0,0,.52.16,1.15,1.15,0,0,0,.84-.65A5.43,5.43,0,0,0,108,148.72Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M104.9,146.5a2.83,2.83,0,0,1,0-.71,1.29,1.29,0,0,1,0-.19s0-.08,0-.09h0s-.13.11-.15.14a2.73,2.73,0,0,1-.62.4c-.58.27-1.18.32-1.55.72a1.33,1.33,0,0,0-.31,1.07.74.74,0,0,0,.3.49.65.65,0,0,0,.66,0,1.12,1.12,0,0,0,.32-.27.93.93,0,0,0,.26,1.07.6.6,0,0,0,.54,0,1.19,1.19,0,0,0,.7-.82A5.47,5.47,0,0,0,104.9,146.5Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M101.84,144.57a2.42,2.42,0,0,1,0-.71l0-.19a.51.51,0,0,0,0-.09h0s-.13.11-.16.13a2.51,2.51,0,0,1-.61.41c-.59.26-1.19.32-1.55.72a1.28,1.28,0,0,0-.31,1.06.72.72,0,0,0,.3.49.63.63,0,0,0,.65,0,1,1,0,0,0,.33-.27.91.91,0,0,0,.26,1.06.63.63,0,0,0,.54.05,1.23,1.23,0,0,0,.7-.82A5.72,5.72,0,0,0,101.84,144.57Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M98.46,142.56a2.64,2.64,0,0,1-.22-.67l0-.19c0-.06,0-.08,0-.09h0s-.09.16-.11.18a2.27,2.27,0,0,1-.44.61c-.46.48-1,.75-1.22,1.27a1.34,1.34,0,0,0,0,1.11.6.6,0,0,0,1,.09,1.09,1.09,0,0,0,.22-.38.88.88,0,0,0,.58.9.6.6,0,0,0,.52-.16,1.27,1.27,0,0,0,.4-1C99.18,143.63,98.75,143.18,98.46,142.56Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M95.32,141.51a2.91,2.91,0,0,1-.18-.69,1.11,1.11,0,0,1,0-.19c0-.06,0-.08,0-.08s0,0,0,0h0s-.1.15-.11.18a2.7,2.7,0,0,1-.48.58c-.49.45-1,.68-1.29,1.19a1.31,1.31,0,0,0,0,1.11.64.64,0,0,0,.42.37.62.62,0,0,0,.62-.22,1,1,0,0,0,.24-.36.87.87,0,0,0,.54.93.57.57,0,0,0,.52-.13,1.24,1.24,0,0,0,.45-1A5.21,5.21,0,0,0,95.32,141.51Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M91.42,141a2.89,2.89,0,0,1-.29-.64,1.05,1.05,0,0,0,0-.19c0-.06,0-.08,0-.08h0s-.07.16-.08.19a3.07,3.07,0,0,1-.38.66c-.41.53-.92.87-1.08,1.41a1.29,1.29,0,0,0,.17,1.1.62.62,0,0,0,.47.29.7.7,0,0,0,.58-.33,1.22,1.22,0,0,0,.18-.4c.06.45.33.8.67.82a.65.65,0,0,0,.5-.23,1.31,1.31,0,0,0,.28-1.07C92.24,141.93,91.77,141.53,91.42,141Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M87.74,141.1a2.49,2.49,0,0,1-.32-.63l-.06-.18s0-.08,0-.08h0s-.06.17-.07.2a2.77,2.77,0,0,1-.34.69c-.38.55-.88.92-1,1.47a1.35,1.35,0,0,0,.23,1.09.63.63,0,0,0,.49.25.69.69,0,0,0,.56-.36,1.34,1.34,0,0,0,.15-.41c.09.44.38.77.72.77a.61.61,0,0,0,.49-.26,1.29,1.29,0,0,0,.22-1.08C88.62,142,88.12,141.65,87.74,141.1Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M84,141.67a2.72,2.72,0,0,1-.51-.46l-.11-.15-.06-.06h0s0,.18,0,.21a2.88,2.88,0,0,1-.1.78,5.5,5.5,0,0,0-.45,1.76,1.27,1.27,0,0,0,.57.93.61.61,0,0,0,.54.05.73.73,0,0,0,.4-.56,1.29,1.29,0,0,0,0-.44.8.8,0,0,0,.93.45.7.7,0,0,0,.37-.43,1.33,1.33,0,0,0-.15-1.1C85.08,142.19,84.5,142,84,141.67Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M80.65,143a2.41,2.41,0,0,1-.51-.46.58.58,0,0,1-.11-.15l-.06-.06v0h0s0,.19,0,.22a3.32,3.32,0,0,1-.1.77,5.35,5.35,0,0,0-.46,1.76,1.25,1.25,0,0,0,.57.93.62.62,0,0,0,.54.06.76.76,0,0,0,.41-.56,1.35,1.35,0,0,0,0-.45c.23.39.6.59.92.45a.65.65,0,0,0,.37-.43,1.33,1.33,0,0,0-.14-1.1C81.77,143.56,81.18,143.4,80.65,143Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M77.54,144.69a2.36,2.36,0,0,1-.57-.36l-.14-.13s0,0-.06,0h0s0,.18,0,.21a2.92,2.92,0,0,1,0,.78,5.44,5.44,0,0,0-.17,1.82,1.23,1.23,0,0,0,.71.81.63.63,0,0,0,.54,0,.76.76,0,0,0,.31-.63,1.07,1.07,0,0,0-.06-.43.78.78,0,0,0,1,.27.74.74,0,0,0,.3-.5,1.28,1.28,0,0,0-.32-1C78.73,145,78.13,145,77.54,144.69Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M74.61,147.51a2.51,2.51,0,0,1-.66,0l-.17-.05s-.08,0-.08,0h0s.09.15.11.18a2.47,2.47,0,0,1,.34.69,5.34,5.34,0,0,0,.57,1.72,1.12,1.12,0,0,0,1,.4.64.64,0,0,0,.46-.3.77.77,0,0,0,0-.71,1.2,1.2,0,0,0-.23-.37.78.78,0,0,0,1-.21.79.79,0,0,0,.07-.59,1.19,1.19,0,0,0-.71-.8C75.8,147.23,75.24,147.47,74.61,147.51Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M68.15,128s14.28-1.52,21.56-4.26l2.51,2.45s-18.64,4.51-23.74,4.24Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.43,125.29a1.85,1.85,0,0,1,.37-.37l.11-.08s0,0,0,0h0s-.14,0-.16,0a1.81,1.81,0,0,1-.56-.12c-.47-.17-.84-.48-1.26-.46a.91.91,0,0,0-.72.4.53.53,0,0,0-.07.42.54.54,0,0,0,.38.35.88.88,0,0,0,.33,0,.63.63,0,0,0-.39.7.49.49,0,0,0,.29.32.91.91,0,0,0,.82,0C90,126.15,90.13,125.7,90.43,125.29Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.83,126.08a1.85,1.85,0,0,1,.36-.38l.12-.08a.11.11,0,0,0,0,0h0s-.13,0-.15,0a2.17,2.17,0,0,1-.56-.13c-.47-.17-.85-.48-1.26-.46a.91.91,0,0,0-.72.4.53.53,0,0,0-.07.42.52.52,0,0,0,.38.35.88.88,0,0,0,.33,0,.64.64,0,0,0-.39.71.49.49,0,0,0,.29.31.89.89,0,0,0,.81,0C87.37,126.93,87.52,126.48,87.83,126.08Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.19,126.85a1.94,1.94,0,0,1,.4-.34l.13-.06,0,0h0s-.14,0-.16,0a1.72,1.72,0,0,1-.54-.18c-.46-.22-.8-.55-1.21-.58a.89.89,0,0,0-.75.32.5.5,0,0,0-.12.42.54.54,0,0,0,.35.39.79.79,0,0,0,.32.06.65.65,0,0,0-.46.67.52.52,0,0,0,.26.34.89.89,0,0,0,.81,0C84.65,127.66,84.85,127.22,85.19,126.85Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.52,127.37a2.32,2.32,0,0,1,.41-.34l.12-.06s0,0,0,0,0,0,0,0a0,0,0,0,0,0,0s-.13,0-.16,0a1.72,1.72,0,0,1-.54-.18c-.45-.22-.79-.55-1.21-.58a.89.89,0,0,0-.75.32.55.55,0,0,0-.12.42.59.59,0,0,0,.35.39.83.83,0,0,0,.32.06.65.65,0,0,0-.46.67.55.55,0,0,0,.26.34.91.91,0,0,0,.82,0C82,128.18,82.18,127.74,82.52,127.37Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.85,127.91a1.88,1.88,0,0,1,.41-.32l.13-.06s0,0,0,0h0s-.13,0-.16,0a2.14,2.14,0,0,1-.53-.2c-.45-.24-.77-.59-1.19-.63a1,1,0,0,0-.76.3.52.52,0,0,0-.13.41.53.53,0,0,0,.33.4.79.79,0,0,0,.32.08.64.64,0,0,0-.48.65.5.5,0,0,0,.24.35.91.91,0,0,0,.82.06C79.28,128.7,79.49,128.27,79.85,127.91Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.16,128.34a1.94,1.94,0,0,1,.42-.32l.13-.07s.05,0,.05,0h0s-.14,0-.16,0a1.6,1.6,0,0,1-.53-.19c-.45-.24-.78-.59-1.19-.63a.9.9,0,0,0-.76.29.51.51,0,0,0-.14.41.58.58,0,0,0,.34.41.78.78,0,0,0,.31.07.64.64,0,0,0-.47.65.49.49,0,0,0,.24.36.92.92,0,0,0,.81.06C76.6,129.12,76.81,128.7,77.16,128.34Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.44,128.78a1.5,1.5,0,0,1,.43-.3.52.52,0,0,1,.13-.06l0,0h0s-.13,0-.15-.05a1.65,1.65,0,0,1-.53-.22c-.43-.26-.74-.62-1.16-.68a.92.92,0,0,0-.77.26.52.52,0,0,0-.15.4.55.55,0,0,0,.31.42.8.8,0,0,0,.32.09.65.65,0,0,0-.51.63.52.52,0,0,0,.22.36,1,1,0,0,0,.82.1C73.84,129.54,74.07,129.12,74.44,128.78Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.71,129.16a1.88,1.88,0,0,1,.41-.32l.13-.07s0,0,0,0h0s-.13,0-.15,0a1.94,1.94,0,0,1-.54-.2c-.45-.24-.77-.58-1.19-.62a.91.91,0,0,0-.76.29.52.52,0,0,0-.13.41.51.51,0,0,0,.33.4.79.79,0,0,0,.32.08.64.64,0,0,0-.48.65.5.5,0,0,0,.24.35.91.91,0,0,0,.82.06C71.14,129.94,71.35,129.52,71.71,129.16Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69,129.58a1.94,1.94,0,0,1,.42-.32l.13-.07s.05,0,.05,0h0s-.13,0-.15,0a1.6,1.6,0,0,1-.53-.19c-.45-.24-.78-.59-1.19-.63a.9.9,0,0,0-.76.29.49.49,0,0,0,.2.81.79.79,0,0,0,.31.08.65.65,0,0,0-.48.65.47.47,0,0,0,.25.35.93.93,0,0,0,.81.07C68.46,130.36,68.67,129.94,69,129.58Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M68.8,150s.56-18.88-.27-21.38S56,106.79,56,106.79l-27.2-2.92s25.87,39,33,44.2A14.63,14.63,0,0,0,68.8,150Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 65.57,
    cy: 130,
    r: 1.87
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "124.44 148 94.82 111.38 90.81 110.83 121.69 148.75 124.44 148"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M93.67,111.76a2.12,2.12,0,0,1-.61-.25l-.15-.09s-.06,0-.07,0,0,0,0,0h0s.05.16.06.19a2.34,2.34,0,0,1,.13.7,4.53,4.53,0,0,0,.07,1.67,1.12,1.12,0,0,0,.8.63.63.63,0,0,0,.52-.11.67.67,0,0,0,.22-.61,1.09,1.09,0,0,0-.11-.39.8.8,0,0,0,1,.1.61.61,0,0,0,.22-.48,1.14,1.14,0,0,0-.44-.92A4.63,4.63,0,0,0,93.67,111.76Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M95.81,114.38a2.55,2.55,0,0,1-.6-.25l-.15-.09s-.07,0-.08,0h0s0,.16.06.19a2.06,2.06,0,0,1,.12.7,4.74,4.74,0,0,0,.08,1.67,1.14,1.14,0,0,0,.8.63.6.6,0,0,0,.52-.12.69.69,0,0,0,.22-.61,1.09,1.09,0,0,0-.11-.38.78.78,0,0,0,1,.1.62.62,0,0,0,.23-.48,1.12,1.12,0,0,0-.45-.92A4.57,4.57,0,0,0,95.81,114.38Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M98,117a2.62,2.62,0,0,1-.61-.25l-.15-.09s-.06,0-.07,0h0s0,0,0,0,0,.16,0,.19a2.34,2.34,0,0,1,.13.7,4.75,4.75,0,0,0,.07,1.67,1.16,1.16,0,0,0,.8.63.65.65,0,0,0,.53-.12.69.69,0,0,0,.22-.61,1,1,0,0,0-.12-.39.8.8,0,0,0,1,.11.65.65,0,0,0,.23-.48,1.15,1.15,0,0,0-.45-.92A4.63,4.63,0,0,0,98,117Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M100.11,119.61a2.21,2.21,0,0,1-.61-.24l-.15-.09-.07,0h0s0,.16.06.18a2.47,2.47,0,0,1,.13.71,4.53,4.53,0,0,0,.07,1.67,1.14,1.14,0,0,0,.8.63.63.63,0,0,0,.52-.12.66.66,0,0,0,.22-.61,1.15,1.15,0,0,0-.11-.39.8.8,0,0,0,1,.11.61.61,0,0,0,.22-.48,1.14,1.14,0,0,0-.44-.92A4.85,4.85,0,0,0,100.11,119.61Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M102.25,122.23a2.15,2.15,0,0,1-.6-.24l-.15-.09-.08,0h0s0,.15.06.18a2.16,2.16,0,0,1,.12.71,4.75,4.75,0,0,0,.08,1.67,1.12,1.12,0,0,0,.79.63A.65.65,0,0,0,103,125a.66.66,0,0,0,.22-.61,1.15,1.15,0,0,0-.11-.39.79.79,0,0,0,1,.11.64.64,0,0,0,.23-.49,1.11,1.11,0,0,0-.45-.91A4.72,4.72,0,0,0,102.25,122.23Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M104.4,124.85a2.21,2.21,0,0,1-.61-.24l-.15-.1a.11.11,0,0,0-.07,0h0s0,.16,0,.19a2.47,2.47,0,0,1,.13.7,4.82,4.82,0,0,0,.07,1.68,1.16,1.16,0,0,0,.8.63.63.63,0,0,0,.52-.12.68.68,0,0,0,.23-.61,1,1,0,0,0-.12-.39.8.8,0,0,0,1,.11.67.67,0,0,0,.23-.49,1.14,1.14,0,0,0-.45-.91A4.85,4.85,0,0,0,104.4,124.85Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M106.55,127.47a2.09,2.09,0,0,1-.61-.24l-.15-.1-.07,0a0,0,0,0,0,0,0h0s0,.16.06.19a2.4,2.4,0,0,1,.13.7,4.53,4.53,0,0,0,.07,1.67,1.13,1.13,0,0,0,.8.64.62.62,0,0,0,.74-.73,1.15,1.15,0,0,0-.11-.39.81.81,0,0,0,1,.11.63.63,0,0,0,.22-.49,1.13,1.13,0,0,0-.44-.91C107.75,127.58,107.16,127.63,106.55,127.47Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M108.69,130.09a2.51,2.51,0,0,1-.6-.24l-.15-.1s-.07,0-.08,0h0s.05.16.06.19a2.1,2.1,0,0,1,.12.7,4.74,4.74,0,0,0,.08,1.67,1.13,1.13,0,0,0,.8.64.68.68,0,0,0,.52-.12.7.7,0,0,0,.22-.61,1,1,0,0,0-.12-.39.82.82,0,0,0,1,.11.64.64,0,0,0,.23-.49,1.1,1.1,0,0,0-.45-.91C109.9,130.2,109.3,130.25,108.69,130.09Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M110.84,132.71a2.57,2.57,0,0,1-.61-.24l-.15-.1s-.06,0-.07,0h0s0,.16,0,.19a2.4,2.4,0,0,1,.13.7,4.75,4.75,0,0,0,.07,1.67,1.15,1.15,0,0,0,.8.64.67.67,0,0,0,.52-.12.68.68,0,0,0,.23-.61,1.17,1.17,0,0,0-.12-.39.82.82,0,0,0,1,.11.67.67,0,0,0,.23-.49,1.15,1.15,0,0,0-.45-.92A4.86,4.86,0,0,0,110.84,132.71Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M113,135.33a2.42,2.42,0,0,1-.61-.24l-.15-.1s-.06,0-.07,0h0s0,.16.06.19a2.34,2.34,0,0,1,.13.7,4.53,4.53,0,0,0,.07,1.67,1.09,1.09,0,0,0,.8.63.63.63,0,0,0,.52-.11.67.67,0,0,0,.22-.61,1.15,1.15,0,0,0-.11-.39.8.8,0,0,0,1,.1.61.61,0,0,0,.22-.48,1.14,1.14,0,0,0-.44-.92A4.63,4.63,0,0,0,113,135.33Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M115.13,138a2.55,2.55,0,0,1-.6-.25,1.19,1.19,0,0,1-.15-.09s-.07,0-.08,0h0s0,.16.06.19a2.34,2.34,0,0,1,.12.7,4.74,4.74,0,0,0,.08,1.67,1.12,1.12,0,0,0,.79.63.62.62,0,0,0,.53-.12.67.67,0,0,0,.22-.6.93.93,0,0,0-.12-.39.8.8,0,0,0,1,.1.62.62,0,0,0,.23-.48,1.15,1.15,0,0,0-.45-.92A4.57,4.57,0,0,0,115.13,138Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M117.28,140.57a2.62,2.62,0,0,1-.61-.25l-.15-.09-.07,0v0s0,0,0,0,0,.16,0,.19a2.34,2.34,0,0,1,.13.7,4.75,4.75,0,0,0,.07,1.67,1.16,1.16,0,0,0,.8.63.6.6,0,0,0,.52-.12.67.67,0,0,0,.23-.61,1,1,0,0,0-.12-.39.79.79,0,0,0,1,.11.65.65,0,0,0,.23-.48,1.15,1.15,0,0,0-.45-.92A4.63,4.63,0,0,0,117.28,140.57Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M119.43,143.19a2.45,2.45,0,0,1-.61-.25l-.15-.09-.07,0v0s0,0,0,0,0,.16.06.18a2.47,2.47,0,0,1,.13.71,4.53,4.53,0,0,0,.07,1.67,1.14,1.14,0,0,0,.8.63.63.63,0,0,0,.52-.12.66.66,0,0,0,.22-.61,1.15,1.15,0,0,0-.11-.39.8.8,0,0,0,1,.11.61.61,0,0,0,.22-.48,1.12,1.12,0,0,0-.45-.92A4.51,4.51,0,0,0,119.43,143.19Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M121.57,145.8a2.15,2.15,0,0,1-.6-.24l-.15-.09a.18.18,0,0,0-.08,0h0s0,.17.06.19a2.16,2.16,0,0,1,.12.71A4.76,4.76,0,0,0,121,148a1.12,1.12,0,0,0,.79.63.65.65,0,0,0,.53-.12.69.69,0,0,0,.22-.61,1,1,0,0,0-.12-.39.8.8,0,0,0,1,.11.62.62,0,0,0,.23-.49,1.11,1.11,0,0,0-.45-.91A4.78,4.78,0,0,0,121.57,145.8Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "114.36 150.29 78.22 109.57 75.53 109.63 113.01 151 114.91 150.41"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.78,148.07s1.08-15.94.41-18.11-14.66-23.83-14.66-23.83H46.36L61,130.46a161,161,0,0,1-.34,16.83Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M69,191.61a55.4,55.4,0,0,1-2.51,11.58A2.4,2.4,0,0,0,68.42,202a3.88,3.88,0,0,0,.53-1.34,2.85,2.85,0,0,0,2.56,2.47,2.28,2.28,0,0,0,1.69-.87,4,4,0,0,0,.73-3.54c-.49-1.77-2.24-2.94-3.61-4.7a8.37,8.37,0,0,1-1.18-2C69.09,191.87,69.05,191.73,69,191.61Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M97.63,196.08A5.16,5.16,0,0,1,97,195l-.12-.33c0-.1,0-.14-.07-.14s0,0,0,0h0c-.07,0-.12.31-.14.37a4.74,4.74,0,0,1-.66,1.26c-.73,1-1.7,1.72-1.93,2.73a2.27,2.27,0,0,0,.48,2,1.34,1.34,0,0,0,1,.46,1.39,1.39,0,0,0,1.1-.69,2.56,2.56,0,0,0,.29-.76,1.61,1.61,0,0,0,1.45,1.39,1.29,1.29,0,0,0,1-.49,2.27,2.27,0,0,0,.41-2C99.4,197.73,98.41,197.08,97.63,196.08Z"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 162.69 37.37 160.71 37.37 163.99 41.33 165.96 41.33 162.69"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 159.41 37.37 157.43 37.37 160.71 41.33 162.69 41.33 159.41"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 156.14 37.37 154.16 37.37 157.43 41.33 159.41 41.33 156.14"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 152.86 37.37 150.88 37.37 154.16 41.33 156.14 41.33 152.86"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 149.58 37.37 147.6 37.37 150.88 41.33 152.86 41.33 149.58"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 146.31 37.37 144.33 37.37 147.6 41.33 149.58 41.33 146.31"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 143.03 37.37 141.05 37.37 144.33 41.33 146.31 41.33 143.03"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 139.75 37.37 137.78 37.37 141.05 41.33 143.03 41.33 139.75"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 136.48 37.37 134.5 37.37 137.78 41.33 139.75 41.33 136.48"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 133.2 37.37 131.22 37.37 134.5 41.33 136.48 41.33 133.2"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 129.93 37.37 127.94 37.37 131.22 41.33 133.2 41.33 129.93"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 126.65 37.37 124.67 37.37 127.94 41.33 129.93 41.33 126.65"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 123.37 37.37 121.39 37.37 124.67 41.33 126.65 41.33 123.37"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 120.1 37.37 118.12 37.37 121.39 41.33 123.37 41.33 120.1"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 116.82 37.37 114.84 37.37 118.12 41.33 120.1 41.33 116.82"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 113.55 37.37 111.57 37.37 114.84 41.33 116.82 41.33 113.55"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "41.33 110.27 37.37 108.29 37.37 111.57 41.33 113.55 41.33 110.27"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "41.33 106.99 37.37 105.01 37.37 108.29 41.33 110.27 41.33 106.99"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 36.44,
    y: 146.49,
    width: 5.64,
    height: 11.28
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    width: 20,
    height: 20,
    transform: "translate(29.52 157.07)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAACPklEQVQ4T6WU627bMAxGDynJyfZCW7f26Vugb5Q4lkjuBxUt3QUYMAKCZVs6vHyUJCL4k72+vecPAf6w5OX5SX7/CvIr8A5SFTwCVeW+ptaKiBDu9D6A38EfgI9RlVIQyRcRodaCzPlxHJg7IoKZ8fL9J7T+Daaqa4gIEY6qgght21AbiCi/mkREwqaPWusCbVtDRTEzWmuIZIT77UYthf12A+A4Dr4/fRGA5UJEFuh8PnE+n2m10lrl8+dPtK3RWqO1yrY1aq2cThsiQmt1ZVhf395Di1JKoc5U0+LBn6BZUESUrTUQwcMpxXnUoebyHIggmhtryfKWUohgppuKq5YJK5xOqfraN90mbEaRCstSuRRBpjhFFPdAQjKJmA+PByAQ4ct7RBARlFpRSVhRJVsoezTCASXCZ3ZMoDBrIKgKMv/UVrMUkvW7R5/iCe5kpKqICq21CQymEFkjUaWWbOKffciCzRkA7oYgREA/OjBldHfuz0wFzAYRjlkesYhY68bo8xv4LFXbMkJ9eX4SN8fdGKNzHAe9dyJgDMtNnjAzm/PAzAA4bgeXy2VFuERxD8BRLZgbw8aqp4jgnkfP3Yhw9j3P8xiDUspysC6H+/ErpbBtGyrC6XTCwxGEUrLOrbWZstB7p/fO5Xrl+dvXj0cPgNnA+74zzLhcr9hIz31kLcfojGHs+85xHFz3fcE+RHi317f3EE2FM5rBtm2z97OtxhgMM8xsXQp/BT6CIftx9MHdiarSj/7vN/b/2g8G7VmheTQM+gAAAABJRU5ErkJggg=="
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "44.42 159.22 47.75 157.22 46.25 160.89 44.42 159.22"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "48.25 165.3 51.99 166.34 48.3 167.78 48.25 165.3"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "46.48 172.26 48.31 175.69 44.72 174.01 46.48 172.26"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "40.22 175.78 38.99 179.47 37.74 175.71 40.22 175.78"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "33.35 173.66 29.84 175.31 31.7 171.82 33.35 173.66"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "30.16 167.23 26.54 165.81 30.35 164.76 30.16 167.23"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "32.62 160.48 31.15 156.88 34.55 158.92 32.62 160.48"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M38.11,166.79A1.17,1.17,0,1,1,39.28,168,1.16,1.16,0,0,1,38.11,166.79Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11H);
export default __webpack_public_path__ + "static/media/11_h.4d518c4e4b47e532590a3fe9fae01466.svg";
export { ForwardRef as ReactComponent };